// WARNING: This file is dynamically generated by build_portable_sprite.js.
// DO NOT edit this file directly.
import { SpriteSheet } from './portableSpriteTypes';

const spriteSheet: SpriteSheet = {
  sheetProps: {
    width: 3454,
    height: 3345,
    spriteSize: 96,
    url: '/images/connector_icons/portable_sprite_2026-03-23T12:25:54.836Z.png',
  },
  sprites: {
    '100ms': {
      x: 0,
      y: 0,
      width: 96,
      height: 96,
    },
    '1msg': {
      x: 2880,
      y: 3264,
      width: 96,
      height: 34,
    },
    '2chat': {
      x: 96,
      y: 0,
      width: 96,
      height: 96,
    },
    '3scribe': {
      x: 0,
      y: 96,
      width: 96,
      height: 96,
    },
    '4d': {
      x: 96,
      y: 96,
      width: 96,
      height: 96,
    },
    '4yousee': {
      x: 192,
      y: 0,
      width: 96,
      height: 96,
    },
    '7shifts': {
      x: 192,
      y: 96,
      width: 96,
      height: 96,
    },
    '8x8_contact_center_analytics': {
      x: 0,
      y: 192,
      width: 96,
      height: 96,
    },
    '8x8_work_analytics': {
      x: 96,
      y: 192,
      width: 96,
      height: 96,
    },
    abyssale: {
      x: 192,
      y: 192,
      width: 96,
      height: 96,
    },
    academyocean: {
      x: 480,
      y: 3264,
      width: 96,
      height: 49,
    },
    accelevents: {
      x: 288,
      y: 0,
      width: 96,
      height: 96,
    },
    activetrail: {
      x: 288,
      y: 96,
      width: 96,
      height: 96,
    },
    acuity_scheduling: {
      x: 288,
      y: 192,
      width: 96,
      height: 96,
    },
    acunetix360: {
      x: 0,
      y: 288,
      width: 96,
      height: 96,
    },
    ad4game: {
      x: 96,
      y: 288,
      width: 96,
      height: 96,
    },
    adaptivework: {
      x: 2399,
      y: 3168,
      width: 96,
      height: 53,
    },
    adbutler: {
      x: 192,
      y: 288,
      width: 96,
      height: 96,
    },
    addepar: {
      x: 288,
      y: 288,
      width: 96,
      height: 96,
    },
    adikteev: {
      x: 384,
      y: 0,
      width: 96,
      height: 96,
    },
    admithub: {
      x: 384,
      y: 96,
      width: 96,
      height: 96,
    },
    adobe_cja: {
      x: 384,
      y: 192,
      width: 96,
      height: 96,
    },
    adrecord: {
      x: 384,
      y: 288,
      width: 96,
      height: 96,
    },
    adswizz: {
      x: 0,
      y: 384,
      width: 96,
      height: 96,
    },
    adtelligent: {
      x: 96,
      y: 384,
      width: 96,
      height: 96,
    },
    adtraction: {
      x: 192,
      y: 384,
      width: 96,
      height: 96,
    },
    adzuna: {
      x: 288,
      y: 384,
      width: 96,
      height: 96,
    },
    affinda: {
      x: 384,
      y: 384,
      width: 96,
      height: 96,
    },
    afosto: {
      x: 3358,
      y: 89,
      width: 96,
      height: 21,
    },
    afterlogic: {
      x: 480,
      y: 0,
      width: 96,
      height: 96,
    },
    aftership: {
      x: 1343,
      y: 3168,
      width: 96,
      height: 82,
    },
    aftership_returns: {
      x: 480,
      y: 96,
      width: 96,
      height: 96,
    },
    aftership_tracking: {
      x: 1439,
      y: 3168,
      width: 96,
      height: 82,
    },
    agencyjoy: {
      x: 480,
      y: 192,
      width: 96,
      height: 96,
    },
    agendor: {
      x: 480,
      y: 288,
      width: 96,
      height: 96,
    },
    agilecrm: {
      x: 480,
      y: 384,
      width: 96,
      height: 96,
    },
    ahrefs: {
      x: 0,
      y: 480,
      width: 96,
      height: 96,
    },
    ai_zendesk_support_categorize_tickets: {
      x: 96,
      y: 480,
      width: 96,
      height: 96,
    },
    ai_zendesk_support_draft_ticket_responses: {
      x: 192,
      y: 480,
      width: 96,
      height: 96,
    },
    aimtell: {
      x: 288,
      y: 480,
      width: 96,
      height: 96,
    },
    airmeet: {
      x: 384,
      y: 480,
      width: 96,
      height: 96,
    },
    airops: {
      x: 480,
      y: 480,
      width: 96,
      height: 96,
    },
    airparser: {
      x: 2592,
      y: 3314,
      width: 96,
      height: 23,
    },
    airship: {
      x: 576,
      y: 0,
      width: 96,
      height: 96,
    },
    alegra: {
      x: 576,
      y: 96,
      width: 96,
      height: 96,
    },
    algodocs: {
      x: 576,
      y: 192,
      width: 96,
      height: 96,
    },
    all_digital_rewards: {
      x: 576,
      y: 288,
      width: 96,
      height: 96,
    },
    altoviz: {
      x: 576,
      y: 384,
      width: 96,
      height: 96,
    },
    americommerce: {
      x: 1535,
      y: 3168,
      width: 96,
      height: 79,
    },
    amilia: {
      x: 576,
      y: 480,
      width: 96,
      height: 96,
    },
    amplifier: {
      x: 0,
      y: 576,
      width: 96,
      height: 96,
    },
    anura: {
      x: 1344,
      y: 3264,
      width: 96,
      height: 42,
    },
    ape_wisdom: {
      x: 96,
      y: 576,
      width: 96,
      height: 96,
    },
    apify: {
      x: 192,
      y: 576,
      width: 96,
      height: 96,
    },
    apollo_io: {
      x: 288,
      y: 576,
      width: 96,
      height: 96,
    },
    apparelmagic: {
      x: 384,
      y: 576,
      width: 96,
      height: 96,
    },
    appbot: {
      x: 480,
      y: 576,
      width: 96,
      height: 96,
    },
    apperio: {
      x: 576,
      y: 576,
      width: 96,
      height: 96,
    },
    appfollow: {
      x: 672,
      y: 0,
      width: 96,
      height: 96,
    },
    apple_app_store: {
      x: 672,
      y: 96,
      width: 96,
      height: 96,
    },
    applicantstack: {
      x: 3358,
      y: 152,
      width: 96,
      height: 20,
    },
    appliedsystems_epic: {
      x: 3358,
      y: 172,
      width: 96,
      height: 20,
    },
    applovin_reporting: {
      x: 672,
      y: 192,
      width: 96,
      height: 96,
    },
    appscan: {
      x: 672,
      y: 288,
      width: 96,
      height: 96,
    },
    appsflyer_pull_api: {
      x: 672,
      y: 384,
      width: 96,
      height: 96,
    },
    apptoto: {
      x: 672,
      y: 480,
      width: 96,
      height: 96,
    },
    arbox: {
      x: 672,
      y: 576,
      width: 96,
      height: 96,
    },
    arcadia: {
      x: 0,
      y: 672,
      width: 96,
      height: 96,
    },
    arcadia_plug: {
      x: 96,
      y: 672,
      width: 96,
      height: 96,
    },
    arcadia_utility_cloud: {
      x: 192,
      y: 672,
      width: 96,
      height: 96,
    },
    arcsecond: {
      x: 288,
      y: 672,
      width: 96,
      height: 96,
    },
    argus: {
      x: 2496,
      y: 3264,
      width: 96,
      height: 37,
    },
    argyle: {
      x: 384,
      y: 672,
      width: 96,
      height: 96,
    },
    arrivy: {
      x: 480,
      y: 672,
      width: 96,
      height: 96,
    },
    asaas: {
      x: 576,
      y: 672,
      width: 96,
      height: 96,
    },
    askkodiak: {
      x: 672,
      y: 672,
      width: 96,
      height: 96,
    },
    asknicely: {
      x: 768,
      y: 0,
      width: 96,
      height: 96,
    },
    aspireiq: {
      x: 768,
      y: 96,
      width: 96,
      height: 96,
    },
    atera: {
      x: 768,
      y: 192,
      width: 96,
      height: 96,
    },
    atlas_so: {
      x: 768,
      y: 288,
      width: 96,
      height: 96,
    },
    atsanywhere: {
      x: 3358,
      y: 387,
      width: 96,
      height: 18,
    },
    audienceful: {
      x: 768,
      y: 384,
      width: 96,
      height: 96,
    },
    audiostack: {
      x: 2016,
      y: 3314,
      width: 96,
      height: 24,
    },
    authorize_net: {
      x: 768,
      y: 480,
      width: 96,
      height: 96,
    },
    autodesk_construction_cloud: {
      x: 768,
      y: 576,
      width: 96,
      height: 96,
    },
    autopilot: {
      x: 768,
      y: 672,
      width: 96,
      height: 96,
    },
    avatax: {
      x: 0,
      y: 768,
      width: 96,
      height: 96,
    },
    avaza: {
      x: 96,
      y: 768,
      width: 96,
      height: 96,
    },
    avochato: {
      x: 192,
      y: 768,
      width: 96,
      height: 96,
    },
    avosms: {
      x: 288,
      y: 768,
      width: 96,
      height: 96,
    },
    awardwallet: {
      x: 384,
      y: 768,
      width: 96,
      height: 96,
    },
    aweber: {
      x: 3358,
      y: 192,
      width: 96,
      height: 20,
    },
    axleapi: {
      x: 480,
      y: 768,
      width: 96,
      height: 96,
    },
    axonaut: {
      x: 576,
      y: 768,
      width: 96,
      height: 96,
    },
    ayanza: {
      x: 672,
      y: 768,
      width: 96,
      height: 96,
    },
    ayrshare: {
      x: 768,
      y: 768,
      width: 96,
      height: 96,
    },
    bannerbite: {
      x: 864,
      y: 0,
      width: 96,
      height: 96,
    },
    baremetrics: {
      x: 864,
      y: 96,
      width: 96,
      height: 96,
    },
    basin: {
      x: 864,
      y: 192,
      width: 96,
      height: 96,
    },
    basis: {
      x: 864,
      y: 288,
      width: 96,
      height: 96,
    },
    batchdialer: {
      x: 864,
      y: 384,
      width: 96,
      height: 96,
    },
    beaglesecurity: {
      x: 864,
      y: 480,
      width: 96,
      height: 96,
    },
    beamer: {
      x: 864,
      y: 576,
      width: 96,
      height: 96,
    },
    beehiiv: {
      x: 2495,
      y: 3168,
      width: 96,
      height: 53,
    },
    beekeeper: {
      x: 864,
      y: 672,
      width: 96,
      height: 96,
    },
    beeline: {
      x: 864,
      y: 768,
      width: 96,
      height: 96,
    },
    beeminder: {
      x: 0,
      y: 864,
      width: 96,
      height: 96,
    },
    belong: {
      x: 96,
      y: 864,
      width: 96,
      height: 96,
    },
    belvo: {
      x: 192,
      y: 864,
      width: 96,
      height: 96,
    },
    benchmark_email: {
      x: 288,
      y: 864,
      width: 96,
      height: 96,
    },
    betterproposals: {
      x: 1728,
      y: 3314,
      width: 96,
      height: 25,
    },
    betterstack: {
      x: 384,
      y: 864,
      width: 96,
      height: 96,
    },
    betteruptime: {
      x: 480,
      y: 864,
      width: 96,
      height: 96,
    },
    bevy: {
      x: 576,
      y: 864,
      width: 96,
      height: 96,
    },
    bexio: {
      x: 672,
      y: 864,
      width: 96,
      height: 96,
    },
    bidsketch: {
      x: 768,
      y: 864,
      width: 96,
      height: 96,
    },
    bigmailer: {
      x: 864,
      y: 864,
      width: 96,
      height: 96,
    },
    bigoven: {
      x: 960,
      y: 0,
      width: 96,
      height: 96,
    },
    bilflo: {
      x: 960,
      y: 96,
      width: 96,
      height: 96,
    },
    bill_com: {
      x: 960,
      y: 192,
      width: 96,
      height: 96,
    },
    billit: {
      x: 960,
      y: 288,
      width: 96,
      height: 96,
    },
    billplz: {
      x: 960,
      y: 384,
      width: 96,
      height: 96,
    },
    billsby: {
      x: 960,
      y: 480,
      width: 96,
      height: 96,
    },
    bim360field: {
      x: 960,
      y: 576,
      width: 96,
      height: 96,
    },
    bitballoon: {
      x: 960,
      y: 672,
      width: 96,
      height: 96,
    },
    bitbucket_cloud: {
      x: 960,
      y: 768,
      width: 96,
      height: 96,
    },
    blackduck: {
      x: 960,
      y: 864,
      width: 96,
      height: 96,
    },
    bland_ai: {
      x: 1440,
      y: 3314,
      width: 96,
      height: 26,
    },
    blink: {
      x: 0,
      y: 960,
      width: 96,
      height: 96,
    },
    blockchain: {
      x: 96,
      y: 960,
      width: 96,
      height: 96,
    },
    bloom_credit: {
      x: 192,
      y: 960,
      width: 96,
      height: 96,
    },
    bloomerang: {
      x: 288,
      y: 960,
      width: 96,
      height: 96,
    },
    bloomreach: {
      x: 384,
      y: 960,
      width: 96,
      height: 96,
    },
    bls: {
      x: 480,
      y: 960,
      width: 96,
      height: 96,
    },
    blueink: {
      x: 576,
      y: 960,
      width: 96,
      height: 96,
    },
    blueshift: {
      x: 672,
      y: 960,
      width: 96,
      height: 96,
    },
    bluesnap: {
      x: 768,
      y: 960,
      width: 96,
      height: 96,
    },
    bolddesk: {
      x: 864,
      y: 960,
      width: 96,
      height: 96,
    },
    boloo: {
      x: 960,
      y: 960,
      width: 96,
      height: 96,
    },
    bolt: {
      x: 1056,
      y: 0,
      width: 96,
      height: 96,
    },
    bonusly: {
      x: 1056,
      y: 96,
      width: 96,
      height: 96,
    },
    booking_manager: {
      x: 1056,
      y: 192,
      width: 96,
      height: 96,
    },
    bookingmood: {
      x: 1056,
      y: 288,
      width: 96,
      height: 96,
    },
    boomtown: {
      x: 1056,
      y: 384,
      width: 96,
      height: 96,
    },
    booqable: {
      x: 3358,
      y: 540,
      width: 96,
      height: 15,
    },
    bossdesk: {
      x: 1056,
      y: 480,
      width: 96,
      height: 96,
    },
    bot9: {
      x: 1056,
      y: 576,
      width: 96,
      height: 96,
    },
    botpenguin: {
      x: 1056,
      y: 672,
      width: 96,
      height: 96,
    },
    bounsel: {
      x: 1056,
      y: 768,
      width: 96,
      height: 96,
    },
    boxhero: {
      x: 1056,
      y: 864,
      width: 96,
      height: 96,
    },
    brandmentions: {
      x: 1056,
      y: 960,
      width: 96,
      height: 96,
    },
    brandwatch: {
      x: 0,
      y: 1056,
      width: 96,
      height: 96,
    },
    brankas: {
      x: 96,
      y: 1056,
      width: 96,
      height: 96,
    },
    bravenewcoin: {
      x: 192,
      y: 1056,
      width: 96,
      height: 96,
    },
    breezy_hr: {
      x: 288,
      y: 1056,
      width: 96,
      height: 96,
    },
    bridge: {
      x: 1728,
      y: 3264,
      width: 96,
      height: 39,
    },
    brightmove: {
      x: 384,
      y: 1056,
      width: 96,
      height: 96,
    },
    brightpattern: {
      x: 480,
      y: 1056,
      width: 96,
      height: 96,
    },
    brilliant: {
      x: 576,
      y: 1056,
      width: 96,
      height: 96,
    },
    broadage: {
      x: 672,
      y: 1056,
      width: 96,
      height: 96,
    },
    brokermint: {
      x: 768,
      y: 1056,
      width: 96,
      height: 96,
    },
    browse_ai: {
      x: 864,
      y: 1056,
      width: 96,
      height: 96,
    },
    browserbear: {
      x: 960,
      y: 1056,
      width: 96,
      height: 96,
    },
    browserhub: {
      x: 1056,
      y: 1056,
      width: 96,
      height: 96,
    },
    browserless: {
      x: 1152,
      y: 0,
      width: 96,
      height: 96,
    },
    bugcrowd: {
      x: 1152,
      y: 96,
      width: 96,
      height: 96,
    },
    bugherd: {
      x: 1152,
      y: 192,
      width: 96,
      height: 96,
    },
    bugsnag: {
      x: 1152,
      y: 288,
      width: 96,
      height: 96,
    },
    builder_io: {
      x: 1152,
      y: 384,
      width: 96,
      height: 96,
    },
    bulksms: {
      x: 1152,
      y: 480,
      width: 96,
      height: 96,
    },
    bunnydoc: {
      x: 1152,
      y: 576,
      width: 96,
      height: 96,
    },
    buttondown: {
      x: 1152,
      y: 672,
      width: 96,
      height: 96,
    },
    buy_me_a_coffee: {
      x: 3264,
      y: 480,
      width: 66,
      height: 96,
    },
    bytenite: {
      x: 1152,
      y: 768,
      width: 96,
      height: 96,
    },
    cadmium_edharvester: {
      x: 1152,
      y: 864,
      width: 96,
      height: 96,
    },
    cakemail: {
      x: 3358,
      y: 292,
      width: 96,
      height: 19,
    },
    cal: {
      x: 1152,
      y: 960,
      width: 96,
      height: 96,
    },
    calendarific: {
      x: 1152,
      y: 1056,
      width: 96,
      height: 96,
    },
    callfire: {
      x: 0,
      y: 1152,
      width: 96,
      height: 96,
    },
    callgear: {
      x: 96,
      y: 1152,
      width: 96,
      height: 96,
    },
    callpage: {
      x: 192,
      y: 1152,
      width: 96,
      height: 96,
    },
    campaigner: {
      x: 288,
      y: 1152,
      width: 96,
      height: 96,
    },
    candid: {
      x: 384,
      y: 1152,
      width: 96,
      height: 96,
    },
    canix: {
      x: 480,
      y: 1152,
      width: 96,
      height: 96,
    },
    capsulecrm: {
      x: 2688,
      y: 3314,
      width: 96,
      height: 23,
    },
    capsulink: {
      x: 576,
      y: 1152,
      width: 96,
      height: 96,
    },
    captain_data: {
      x: 672,
      y: 1152,
      width: 96,
      height: 96,
    },
    captionhub: {
      x: 768,
      y: 1152,
      width: 96,
      height: 96,
    },
    captivateiq: {
      x: 864,
      y: 1152,
      width: 96,
      height: 96,
    },
    cardly: {
      x: 3358,
      y: 311,
      width: 96,
      height: 19,
    },
    cart: {
      x: 960,
      y: 1152,
      width: 96,
      height: 96,
    },
    cartoncloud: {
      x: 1056,
      y: 1152,
      width: 96,
      height: 96,
    },
    cartrack: {
      x: 1152,
      y: 1152,
      width: 96,
      height: 96,
    },
    cartrover: {
      x: 1248,
      y: 0,
      width: 96,
      height: 96,
    },
    cashboard: {
      x: 1248,
      y: 96,
      width: 96,
      height: 96,
    },
    casting42: {
      x: 1248,
      y: 192,
      width: 96,
      height: 96,
    },
    castmagic: {
      x: 1248,
      y: 288,
      width: 96,
      height: 96,
    },
    cats: {
      x: 1248,
      y: 384,
      width: 96,
      height: 96,
    },
    cbre_ea: {
      x: 1248,
      y: 480,
      width: 96,
      height: 96,
    },
    celigo: {
      x: 1248,
      y: 576,
      width: 96,
      height: 96,
    },
    certify: {
      x: 1248,
      y: 672,
      width: 96,
      height: 96,
    },
    channable: {
      x: 1248,
      y: 768,
      width: 96,
      height: 96,
    },
    channelape: {
      x: 1248,
      y: 864,
      width: 96,
      height: 96,
    },
    chaport: {
      x: 1248,
      y: 960,
      width: 96,
      height: 96,
    },
    chargeback: {
      x: 1248,
      y: 1056,
      width: 96,
      height: 96,
    },
    chargeblast: {
      x: 1536,
      y: 3314,
      width: 96,
      height: 26,
    },
    chargeover: {
      x: 3358,
      y: 610,
      width: 96,
      height: 11,
    },
    chatbot: {
      x: 1248,
      y: 1152,
      width: 96,
      height: 96,
    },
    chatfly: {
      x: 0,
      y: 1248,
      width: 96,
      height: 96,
    },
    chatham_financial: {
      x: 96,
      y: 1248,
      width: 96,
      height: 96,
    },
    chattermill: {
      x: 192,
      y: 1248,
      width: 96,
      height: 96,
    },
    chatwoot: {
      x: 288,
      y: 1248,
      width: 96,
      height: 96,
    },
    checkbook: {
      x: 384,
      y: 1248,
      width: 96,
      height: 96,
    },
    checkout_champ: {
      x: 480,
      y: 1248,
      width: 96,
      height: 96,
    },
    cheddar: {
      x: 576,
      y: 1248,
      width: 96,
      height: 96,
    },
    chewy_ads: {
      x: 672,
      y: 1248,
      width: 96,
      height: 96,
    },
    chilipiper: {
      x: 768,
      y: 1248,
      width: 96,
      height: 96,
    },
    cincopa: {
      x: 864,
      y: 1248,
      width: 96,
      height: 96,
    },
    circle_so: {
      x: 960,
      y: 1248,
      width: 96,
      height: 96,
    },
    citrusad: {
      x: 1056,
      y: 1248,
      width: 96,
      height: 96,
    },
    claid_ai: {
      x: 1152,
      y: 1248,
      width: 96,
      height: 96,
    },
    claimcenter: {
      x: 3358,
      y: 441,
      width: 96,
      height: 17,
    },
    classy: {
      x: 1248,
      y: 1248,
      width: 96,
      height: 96,
    },
    clearbit: {
      x: 1344,
      y: 0,
      width: 96,
      height: 96,
    },
    clerk: {
      x: 1344,
      y: 96,
      width: 96,
      height: 96,
    },
    clevertap: {
      x: 1344,
      y: 192,
      width: 96,
      height: 96,
    },
    click2mail: {
      x: 1344,
      y: 288,
      width: 96,
      height: 96,
    },
    clickfunnels: {
      x: 1344,
      y: 384,
      width: 96,
      height: 96,
    },
    clicksend: {
      x: 1344,
      y: 480,
      width: 96,
      height: 96,
    },
    clicktime: {
      x: 1344,
      y: 576,
      width: 96,
      height: 96,
    },
    cliengo: {
      x: 1344,
      y: 672,
      width: 96,
      height: 96,
    },
    client_success: {
      x: 1344,
      y: 768,
      width: 96,
      height: 96,
    },
    clientify: {
      x: 1344,
      y: 864,
      width: 96,
      height: 96,
    },
    clientjoy: {
      x: 1344,
      y: 960,
      width: 96,
      height: 96,
    },
    cloud_assess: {
      x: 1344,
      y: 1056,
      width: 96,
      height: 96,
    },
    cloudcart: {
      x: 1344,
      y: 1152,
      width: 96,
      height: 96,
    },
    cloudconvert: {
      x: 1344,
      y: 1248,
      width: 96,
      height: 96,
    },
    cloudflare: {
      x: 3072,
      y: 3264,
      width: 96,
      height: 32,
    },
    cloudinary: {
      x: 3358,
      y: 330,
      width: 96,
      height: 19,
    },
    cloudlayer: {
      x: 0,
      y: 1344,
      width: 96,
      height: 96,
    },
    cloutly: {
      x: 96,
      y: 1344,
      width: 96,
      height: 96,
    },
    cloze: {
      x: 192,
      y: 1344,
      width: 96,
      height: 96,
    },
    cms_gov: {
      x: 288,
      y: 1344,
      width: 96,
      height: 96,
    },
    coda: {
      x: 384,
      y: 1344,
      width: 96,
      height: 96,
    },
    codacy: {
      x: 480,
      y: 1344,
      width: 96,
      height: 96,
    },
    cody: {
      x: 576,
      y: 1344,
      width: 96,
      height: 96,
    },
    coingecko: {
      x: 672,
      y: 1344,
      width: 96,
      height: 96,
    },
    coinmarketcal: {
      x: 768,
      y: 1344,
      width: 96,
      height: 96,
    },
    coinmarketcap: {
      x: 864,
      y: 1344,
      width: 96,
      height: 96,
    },
    collect: {
      x: 960,
      y: 1344,
      width: 96,
      height: 96,
    },
    combocurve: {
      x: 1056,
      y: 1344,
      width: 96,
      height: 96,
    },
    cometchat: {
      x: 1152,
      y: 1344,
      width: 96,
      height: 96,
    },
    cometly: {
      x: 1248,
      y: 1344,
      width: 96,
      height: 96,
    },
    commcare: {
      x: 1344,
      y: 1344,
      width: 96,
      height: 96,
    },
    commerce7: {
      x: 1440,
      y: 0,
      width: 96,
      height: 96,
    },
    commerce_layer: {
      x: 1440,
      y: 96,
      width: 96,
      height: 96,
    },
    commissionfactory: {
      x: 1440,
      y: 192,
      width: 96,
      height: 96,
    },
    common_room: {
      x: 1440,
      y: 288,
      width: 96,
      height: 96,
    },
    commonpaper: {
      x: 1440,
      y: 384,
      width: 96,
      height: 96,
    },
    commpeak: {
      x: 1440,
      y: 480,
      width: 96,
      height: 96,
    },
    companycam: {
      x: 2688,
      y: 3264,
      width: 96,
      height: 36,
    },
    concord_walmart: {
      x: 2016,
      y: 3264,
      width: 96,
      height: 38,
    },
    connectandsell: {
      x: 1440,
      y: 576,
      width: 96,
      height: 96,
    },
    contentful: {
      x: 1440,
      y: 672,
      width: 96,
      height: 96,
    },
    contentgroove: {
      x: 1440,
      y: 768,
      width: 96,
      height: 96,
    },
    contentking: {
      x: 1440,
      y: 864,
      width: 96,
      height: 96,
    },
    contentstack_delivery: {
      x: 1440,
      y: 960,
      width: 96,
      height: 96,
    },
    contentstack_management: {
      x: 1440,
      y: 1056,
      width: 96,
      height: 96,
    },
    convertio: {
      x: 1440,
      y: 1152,
      width: 96,
      height: 96,
    },
    convertkit: {
      x: 1440,
      y: 1248,
      width: 96,
      height: 96,
    },
    copilot: {
      x: 1440,
      y: 1344,
      width: 96,
      height: 96,
    },
    copperx: {
      x: 0,
      y: 1440,
      width: 96,
      height: 96,
    },
    copy_ai: {
      x: 96,
      y: 1440,
      width: 96,
      height: 96,
    },
    cordial: {
      x: 192,
      y: 1440,
      width: 96,
      height: 96,
    },
    corsizio: {
      x: 288,
      y: 1440,
      width: 96,
      height: 96,
    },
    courier: {
      x: 384,
      y: 1440,
      width: 96,
      height: 96,
    },
    covalent: {
      x: 480,
      y: 1440,
      width: 96,
      height: 96,
    },
    cradl: {
      x: 576,
      y: 1440,
      width: 96,
      height: 96,
    },
    craftboxx: {
      x: 672,
      y: 1440,
      width: 96,
      height: 96,
    },
    craftnet: {
      x: 768,
      y: 1440,
      width: 96,
      height: 96,
    },
    creatomate: {
      x: 864,
      y: 1440,
      width: 96,
      height: 96,
    },
    crelate: {
      x: 960,
      y: 1440,
      width: 96,
      height: 96,
    },
    criteo_marketing: {
      x: 1056,
      y: 1440,
      width: 96,
      height: 96,
    },
    cronofy: {
      x: 1152,
      y: 1440,
      width: 96,
      height: 96,
    },
    crowd: {
      x: 1248,
      y: 1440,
      width: 96,
      height: 96,
    },
    crowdin: {
      x: 1344,
      y: 1440,
      width: 96,
      height: 96,
    },
    crowdtangle: {
      x: 1440,
      y: 1440,
      width: 96,
      height: 96,
    },
    cs_cart: {
      x: 1536,
      y: 0,
      width: 96,
      height: 96,
    },
    curator_io: {
      x: 1536,
      y: 96,
      width: 96,
      height: 96,
    },
    custify: {
      x: 1536,
      y: 192,
      width: 96,
      height: 96,
    },
    customergauge: {
      x: 1536,
      y: 288,
      width: 96,
      height: 96,
    },
    cyberimpact: {
      x: 1536,
      y: 384,
      width: 96,
      height: 96,
    },
    daftra: {
      x: 1536,
      y: 480,
      width: 96,
      height: 96,
    },
    dashdoc: {
      x: 1536,
      y: 576,
      width: 96,
      height: 96,
    },
    data_world: {
      x: 1536,
      y: 672,
      width: 96,
      height: 96,
    },
    datadive: {
      x: 1536,
      y: 768,
      width: 96,
      height: 96,
    },
    datadome_co: {
      x: 1536,
      y: 864,
      width: 96,
      height: 96,
    },
    datanyze: {
      x: 1536,
      y: 960,
      width: 96,
      height: 96,
    },
    dealmachine: {
      x: 1536,
      y: 1056,
      width: 96,
      height: 96,
    },
    debtpaypro: {
      x: 1536,
      y: 1152,
      width: 96,
      height: 96,
    },
    deel: {
      x: 1536,
      y: 1248,
      width: 96,
      height: 96,
    },
    deeptalk_ai: {
      x: 1536,
      y: 1344,
      width: 96,
      height: 96,
    },
    degreed: {
      x: 1536,
      y: 1440,
      width: 96,
      height: 96,
    },
    delta_projects: {
      x: 0,
      y: 1536,
      width: 96,
      height: 96,
    },
    demio: {
      x: 96,
      y: 1536,
      width: 96,
      height: 96,
    },
    denim: {
      x: 192,
      y: 1536,
      width: 96,
      height: 96,
    },
    design_pickle: {
      x: 288,
      y: 1536,
      width: 96,
      height: 96,
    },
    determ: {
      x: 384,
      y: 1536,
      width: 96,
      height: 96,
    },
    devcycle: {
      x: 3358,
      y: 110,
      width: 96,
      height: 21,
    },
    developerhub: {
      x: 480,
      y: 1536,
      width: 96,
      height: 96,
    },
    devskiller: {
      x: 576,
      y: 1536,
      width: 96,
      height: 96,
    },
    dexatel: {
      x: 672,
      y: 1536,
      width: 96,
      height: 96,
    },
    dexscreener: {
      x: 768,
      y: 1536,
      width: 96,
      height: 96,
    },
    dext: {
      x: 864,
      y: 1536,
      width: 96,
      height: 96,
    },
    dialog_insight: {
      x: 960,
      y: 1536,
      width: 96,
      height: 96,
    },
    didacte: {
      x: 1632,
      y: 3314,
      width: 96,
      height: 26,
    },
    diese: {
      x: 2112,
      y: 3314,
      width: 96,
      height: 24,
    },
    digify: {
      x: 1056,
      y: 1536,
      width: 96,
      height: 96,
    },
    digital_turbine: {
      x: 1152,
      y: 1536,
      width: 96,
      height: 96,
    },
    digitalchalk: {
      x: 1248,
      y: 1536,
      width: 96,
      height: 96,
    },
    digitalocean: {
      x: 1344,
      y: 1536,
      width: 96,
      height: 96,
    },
    dingconnect: {
      x: 1440,
      y: 1536,
      width: 96,
      height: 96,
    },
    disco: {
      x: 288,
      y: 3314,
      width: 96,
      height: 29,
    },
    discord_bot: {
      x: 1536,
      y: 1536,
      width: 96,
      height: 96,
    },
    disqo: {
      x: 2208,
      y: 3314,
      width: 96,
      height: 24,
    },
    docdown: {
      x: 1632,
      y: 0,
      width: 96,
      height: 96,
    },
    docparser: {
      x: 1632,
      y: 96,
      width: 96,
      height: 96,
    },
    docsbot: {
      x: 1632,
      y: 192,
      width: 96,
      height: 96,
    },
    docsumo: {
      x: 1632,
      y: 288,
      width: 96,
      height: 96,
    },
    documint: {
      x: 1632,
      y: 384,
      width: 96,
      height: 96,
    },
    documo: {
      x: 1632,
      y: 480,
      width: 96,
      height: 96,
    },
    docupilot: {
      x: 1632,
      y: 576,
      width: 96,
      height: 96,
    },
    doit: {
      x: 1632,
      y: 672,
      width: 96,
      height: 96,
    },
    dola_me: {
      x: 1632,
      y: 768,
      width: 96,
      height: 96,
    },
    donately: {
      x: 1632,
      y: 864,
      width: 96,
      height: 96,
    },
    donorbox: {
      x: 1632,
      y: 960,
      width: 96,
      height: 96,
    },
    donorschoose: {
      x: 1632,
      y: 1056,
      width: 96,
      height: 96,
    },
    dotdigital: {
      x: 3358,
      y: 212,
      width: 96,
      height: 20,
    },
    doubletick: {
      x: 1632,
      y: 1152,
      width: 96,
      height: 96,
    },
    dripcel: {
      x: 1632,
      y: 1248,
      width: 96,
      height: 96,
    },
    dropboy: {
      x: 1632,
      y: 1344,
      width: 96,
      height: 96,
    },
    dryfta: {
      x: 1632,
      y: 1440,
      width: 96,
      height: 96,
    },
    duda: {
      x: 1632,
      y: 1536,
      width: 96,
      height: 96,
    },
    durianpay: {
      x: 0,
      y: 1632,
      width: 96,
      height: 96,
    },
    dutchie_plus: {
      x: 96,
      y: 1632,
      width: 96,
      height: 96,
    },
    dynamo_software: {
      x: 192,
      y: 1632,
      width: 96,
      height: 96,
    },
    easypractice: {
      x: 288,
      y: 1632,
      width: 96,
      height: 96,
    },
    easyship: {
      x: 2304,
      y: 3314,
      width: 96,
      height: 24,
    },
    ebby: {
      x: 2784,
      y: 3314,
      width: 96,
      height: 23,
    },
    ecomail: {
      x: 384,
      y: 1632,
      width: 96,
      height: 96,
    },
    ecompliance: {
      x: 480,
      y: 1632,
      width: 96,
      height: 96,
    },
    eden_ai: {
      x: 576,
      y: 1632,
      width: 96,
      height: 96,
    },
    edume: {
      x: 672,
      y: 1632,
      width: 96,
      height: 96,
    },
    effiliation: {
      x: 768,
      y: 1632,
      width: 96,
      height: 96,
    },
    eia: {
      x: 864,
      y: 1632,
      width: 96,
      height: 96,
    },
    elai: {
      x: 960,
      y: 1632,
      width: 96,
      height: 96,
    },
    elasticemail: {
      x: 1056,
      y: 1632,
      width: 96,
      height: 96,
    },
    elemeno: {
      x: 1152,
      y: 1632,
      width: 96,
      height: 96,
    },
    elevio: {
      x: 1248,
      y: 1632,
      width: 96,
      height: 96,
    },
    emaillistverify: {
      x: 1344,
      y: 1632,
      width: 96,
      height: 96,
    },
    emailoctopus: {
      x: 1440,
      y: 1632,
      width: 96,
      height: 96,
    },
    emarsys: {
      x: 1536,
      y: 1632,
      width: 96,
      height: 96,
    },
    emfluence: {
      x: 2687,
      y: 3168,
      width: 96,
      height: 50,
    },
    emplifi: {
      x: 3358,
      y: 131,
      width: 96,
      height: 21,
    },
    emsi: {
      x: 1632,
      y: 1632,
      width: 96,
      height: 96,
    },
    endear: {
      x: 1728,
      y: 0,
      width: 96,
      height: 96,
    },
    endorsal: {
      x: 1728,
      y: 96,
      width: 96,
      height: 96,
    },
    engagebay: {
      x: 1728,
      y: 192,
      width: 96,
      height: 96,
    },
    enspire_commerce: {
      x: 1728,
      y: 288,
      width: 96,
      height: 96,
    },
    enterprisealumni: {
      x: 1728,
      y: 384,
      width: 96,
      height: 96,
    },
    enverus: {
      x: 1728,
      y: 480,
      width: 96,
      height: 96,
    },
    envi: {
      x: 1728,
      y: 576,
      width: 96,
      height: 96,
    },
    envoke: {
      x: 1728,
      y: 672,
      width: 96,
      height: 96,
    },
    epsilon3: {
      x: 1728,
      y: 768,
      width: 96,
      height: 96,
    },
    erply: {
      x: 1728,
      y: 864,
      width: 96,
      height: 96,
    },
    esignly: {
      x: 1728,
      y: 960,
      width: 96,
      height: 96,
    },
    eventee: {
      x: 1728,
      y: 1056,
      width: 96,
      height: 96,
    },
    eventmaker: {
      x: 1728,
      y: 1152,
      width: 96,
      height: 96,
    },
    eventmobi: {
      x: 1728,
      y: 1248,
      width: 96,
      height: 96,
    },
    eventtia: {
      x: 1728,
      y: 1344,
      width: 96,
      height: 96,
    },
    eventzilla: {
      x: 1728,
      y: 1440,
      width: 96,
      height: 96,
    },
    everbridge: {
      x: 1728,
      y: 1536,
      width: 96,
      height: 96,
    },
    everfit: {
      x: 1728,
      y: 1632,
      width: 96,
      height: 96,
    },
    evergiving: {
      x: 959,
      y: 3168,
      width: 96,
      height: 94,
    },
    evernest: {
      x: 0,
      y: 1728,
      width: 96,
      height: 96,
    },
    everyware: {
      x: 96,
      y: 1728,
      width: 96,
      height: 96,
    },
    evisort: {
      x: 192,
      y: 1728,
      width: 96,
      height: 96,
    },
    evoliz: {
      x: 288,
      y: 1728,
      width: 96,
      height: 96,
    },
    evvnt: {
      x: 384,
      y: 1728,
      width: 96,
      height: 96,
    },
    ex_co: {
      x: 480,
      y: 1728,
      width: 96,
      height: 96,
    },
    exhibitday: {
      x: 576,
      y: 1728,
      width: 96,
      height: 96,
    },
    exploretock: {
      x: 672,
      y: 1728,
      width: 96,
      height: 96,
    },
    ezo_io: {
      x: 768,
      y: 1728,
      width: 96,
      height: 96,
    },
    ezus: {
      x: 864,
      y: 1728,
      width: 96,
      height: 96,
    },
    ezyvet: {
      x: 960,
      y: 1728,
      width: 96,
      height: 96,
    },
    factor_io: {
      x: 1056,
      y: 1728,
      width: 96,
      height: 96,
    },
    factoredquality: {
      x: 1152,
      y: 1728,
      width: 96,
      height: 96,
    },
    fairing_co: {
      x: 1248,
      y: 1728,
      width: 96,
      height: 96,
    },
    fanpower: {
      x: 1344,
      y: 1728,
      width: 96,
      height: 96,
    },
    fantasydata: {
      x: 1440,
      y: 1728,
      width: 96,
      height: 96,
    },
    fareharbor_data: {
      x: 1536,
      y: 1728,
      width: 96,
      height: 96,
    },
    fastly: {
      x: 2112,
      y: 3264,
      width: 96,
      height: 38,
    },
    fathom_analytics: {
      x: 1632,
      y: 1728,
      width: 96,
      height: 96,
    },
    fbi_wanted_api: {
      x: 1728,
      y: 1728,
      width: 96,
      height: 96,
    },
    fda: {
      x: 1824,
      y: 0,
      width: 96,
      height: 96,
    },
    feathery: {
      x: 1824,
      y: 96,
      width: 96,
      height: 96,
    },
    fee_navigator: {
      x: 1824,
      y: 192,
      width: 96,
      height: 96,
    },
    feedly: {
      x: 1824,
      y: 288,
      width: 96,
      height: 96,
    },
    fema_gov: {
      x: 1824,
      y: 384,
      width: 96,
      height: 96,
    },
    fera_ai: {
      x: 1824,
      y: 480,
      width: 96,
      height: 96,
    },
    fibery: {
      x: 1824,
      y: 576,
      width: 96,
      height: 96,
    },
    fieldaware: {
      x: 1824,
      y: 672,
      width: 96,
      height: 96,
    },
    fieldfolio: {
      x: 1824,
      y: 768,
      width: 96,
      height: 96,
    },
    fieldly: {
      x: 2880,
      y: 3314,
      width: 96,
      height: 23,
    },
    fig_finance: {
      x: 1824,
      y: 864,
      width: 96,
      height: 96,
    },
    figma: {
      x: 3264,
      y: 672,
      width: 64,
      height: 96,
    },
    finch: {
      x: 1824,
      y: 960,
      width: 96,
      height: 96,
    },
    findymail: {
      x: 1824,
      y: 1056,
      width: 96,
      height: 96,
    },
    finmei: {
      x: 1824,
      y: 1152,
      width: 96,
      height: 96,
    },
    finmo: {
      x: 1824,
      y: 1248,
      width: 96,
      height: 96,
    },
    fintoc: {
      x: 1824,
      y: 1344,
      width: 96,
      height: 96,
    },
    firefish: {
      x: 1824,
      y: 1440,
      width: 96,
      height: 96,
    },
    firstpromoter: {
      x: 1824,
      y: 1536,
      width: 96,
      height: 96,
    },
    five9: {
      x: 2783,
      y: 3168,
      width: 96,
      height: 50,
    },
    fixably: {
      x: 1824,
      y: 1632,
      width: 96,
      height: 96,
    },
    fleetio: {
      x: 2879,
      y: 3168,
      width: 96,
      height: 50,
    },
    flip: {
      x: 1824,
      y: 1728,
      width: 96,
      height: 96,
    },
    flodesk: {
      x: 0,
      y: 1824,
      width: 96,
      height: 96,
    },
    flow: {
      x: 2975,
      y: 3168,
      width: 96,
      height: 50,
    },
    flow_xo: {
      x: 96,
      y: 1824,
      width: 96,
      height: 96,
    },
    flowcode: {
      x: 192,
      y: 1824,
      width: 96,
      height: 96,
    },
    flux: {
      x: 288,
      y: 1824,
      width: 96,
      height: 96,
    },
    fluxguard: {
      x: 384,
      y: 1824,
      width: 96,
      height: 96,
    },
    fluxiom: {
      x: 480,
      y: 1824,
      width: 96,
      height: 96,
    },
    followupboss: {
      x: 576,
      y: 1824,
      width: 96,
      height: 96,
    },
    fomo: {
      x: 672,
      y: 1824,
      width: 96,
      height: 96,
    },
    formbricks: {
      x: 768,
      y: 1824,
      width: 96,
      height: 96,
    },
    formkeep: {
      x: 864,
      y: 1824,
      width: 96,
      height: 96,
    },
    formsite: {
      x: 960,
      y: 1824,
      width: 96,
      height: 96,
    },
    frame_io: {
      x: 1056,
      y: 1824,
      width: 96,
      height: 96,
    },
    franchimp: {
      x: 1152,
      y: 1824,
      width: 96,
      height: 96,
    },
    freeagent: {
      x: 3358,
      y: 349,
      width: 96,
      height: 19,
    },
    freeclimb: {
      x: 1248,
      y: 1824,
      width: 96,
      height: 96,
    },
    freshcaller: {
      x: 1344,
      y: 1824,
      width: 96,
      height: 96,
    },
    freshmarketer: {
      x: 1440,
      y: 1824,
      width: 96,
      height: 96,
    },
    froged: {
      x: 1536,
      y: 1824,
      width: 96,
      height: 96,
    },
    frontegg: {
      x: 1632,
      y: 1824,
      width: 96,
      height: 96,
    },
    fulcrum: {
      x: 1728,
      y: 1824,
      width: 96,
      height: 96,
    },
    fusioo: {
      x: 1824,
      y: 1824,
      width: 96,
      height: 96,
    },
    futurevault: {
      x: 1920,
      y: 0,
      width: 96,
      height: 96,
    },
    gallabox: {
      x: 1920,
      y: 96,
      width: 96,
      height: 96,
    },
    gamerpower: {
      x: 1920,
      y: 192,
      width: 96,
      height: 96,
    },
    gan: {
      x: 1920,
      y: 288,
      width: 96,
      height: 96,
    },
    gathercontent: {
      x: 1920,
      y: 384,
      width: 96,
      height: 96,
    },
    gatherup: {
      x: 1920,
      y: 480,
      width: 96,
      height: 96,
    },
    gelato: {
      x: 1920,
      y: 576,
      width: 96,
      height: 96,
    },
    genderize: {
      x: 1920,
      y: 672,
      width: 96,
      height: 96,
    },
    genius_referrals: {
      x: 1920,
      y: 768,
      width: 96,
      height: 96,
    },
    getpaid: {
      x: 1920,
      y: 864,
      width: 96,
      height: 96,
    },
    getresponse: {
      x: 1920,
      y: 960,
      width: 96,
      height: 96,
    },
    getyourguide: {
      x: 1920,
      y: 1056,
      width: 96,
      height: 96,
    },
    ghost: {
      x: 576,
      y: 3264,
      width: 96,
      height: 48,
    },
    giftbit: {
      x: 1920,
      y: 1152,
      width: 96,
      height: 96,
    },
    giftpack: {
      x: 1920,
      y: 1248,
      width: 96,
      height: 96,
    },
    giftup: {
      x: 1920,
      y: 1344,
      width: 96,
      height: 96,
    },
    gigs: {
      x: 1920,
      y: 1440,
      width: 96,
      height: 96,
    },
    gingrapp: {
      x: 1920,
      y: 1536,
      width: 96,
      height: 96,
    },
    givebutter: {
      x: 1920,
      y: 1632,
      width: 96,
      height: 96,
    },
    giveforms: {
      x: 1920,
      y: 1728,
      width: 96,
      height: 96,
    },
    givewp: {
      x: 1920,
      y: 1824,
      width: 96,
      height: 96,
    },
    givingfuel: {
      x: 0,
      y: 1920,
      width: 96,
      height: 96,
    },
    glassfrog: {
      x: 96,
      y: 1920,
      width: 96,
      height: 96,
    },
    globalgiving: {
      x: 192,
      y: 1920,
      width: 96,
      height: 96,
    },
    glow: {
      x: 288,
      y: 1920,
      width: 96,
      height: 96,
    },
    goaffpro: {
      x: 384,
      y: 1920,
      width: 96,
      height: 96,
    },
    goflow: {
      x: 480,
      y: 1920,
      width: 96,
      height: 96,
    },
    gong: {
      x: 2015,
      y: 3168,
      width: 96,
      height: 58,
    },
    goody: {
      x: 576,
      y: 1920,
      width: 96,
      height: 96,
    },
    gorilladesk: {
      x: 672,
      y: 1920,
      width: 96,
      height: 96,
    },
    gosquared: {
      x: 768,
      y: 1920,
      width: 96,
      height: 96,
    },
    gotab: {
      x: 2784,
      y: 3264,
      width: 96,
      height: 35,
    },
    goto_connect: {
      x: 864,
      y: 1920,
      width: 96,
      height: 96,
    },
    govinfo: {
      x: 960,
      y: 1920,
      width: 96,
      height: 96,
    },
    gptbots: {
      x: 2111,
      y: 3168,
      width: 96,
      height: 54,
    },
    gravity_forms: {
      x: 1056,
      y: 1920,
      width: 96,
      height: 96,
    },
    grazecart: {
      x: 1152,
      y: 1920,
      width: 96,
      height: 96,
    },
    greenspark: {
      x: 1248,
      y: 1920,
      width: 96,
      height: 96,
    },
    greenstreet: {
      x: 960,
      y: 3264,
      width: 96,
      height: 46,
    },
    griffin: {
      x: 1344,
      y: 1920,
      width: 96,
      height: 96,
    },
    groovehq: {
      x: 1440,
      y: 1920,
      width: 96,
      height: 96,
    },
    gtmhub: {
      x: 1536,
      y: 1920,
      width: 96,
      height: 96,
    },
    guardian_property_systems: {
      x: 1632,
      y: 1920,
      width: 96,
      height: 96,
    },
    guestmeter: {
      x: 2976,
      y: 3264,
      width: 96,
      height: 33,
    },
    guesty: {
      x: 1728,
      y: 1920,
      width: 96,
      height: 96,
    },
    guidebook: {
      x: 1824,
      y: 1920,
      width: 96,
      height: 96,
    },
    guidecx: {
      x: 1920,
      y: 1920,
      width: 96,
      height: 96,
    },
    gumroad: {
      x: 3358,
      y: 584,
      width: 96,
      height: 13,
    },
    habitify: {
      x: 2016,
      y: 0,
      width: 96,
      height: 96,
    },
    hackedu: {
      x: 2016,
      y: 96,
      width: 96,
      height: 96,
    },
    hackerone: {
      x: 2016,
      y: 192,
      width: 96,
      height: 96,
    },
    halosecurity: {
      x: 2016,
      y: 288,
      width: 96,
      height: 96,
    },
    handwrytten: {
      x: 2016,
      y: 384,
      width: 96,
      height: 96,
    },
    happierleads: {
      x: 2016,
      y: 480,
      width: 96,
      height: 96,
    },
    happyrobot_ai: {
      x: 2016,
      y: 576,
      width: 96,
      height: 96,
    },
    harmonic_v2: {
      x: 2016,
      y: 672,
      width: 96,
      height: 96,
    },
    harness: {
      x: 2016,
      y: 768,
      width: 96,
      height: 96,
    },
    hcss: {
      x: 2016,
      y: 864,
      width: 96,
      height: 96,
    },
    healthcare_gov: {
      x: 2016,
      y: 960,
      width: 96,
      height: 96,
    },
    helloasso: {
      x: 2016,
      y: 1056,
      width: 96,
      height: 96,
    },
    helpcrunch: {
      x: 2016,
      y: 1152,
      width: 96,
      height: 96,
    },
    hetrixtools: {
      x: 2016,
      y: 1248,
      width: 96,
      height: 96,
    },
    hexomatic: {
      x: 2016,
      y: 1344,
      width: 96,
      height: 96,
    },
    hexometer: {
      x: 2016,
      y: 1440,
      width: 96,
      height: 96,
    },
    heygen: {
      x: 2016,
      y: 1536,
      width: 96,
      height: 96,
    },
    heyreach: {
      x: 2207,
      y: 3168,
      width: 96,
      height: 54,
    },
    hid_origo: {
      x: 2016,
      y: 1632,
      width: 96,
      height: 96,
    },
    hideliver: {
      x: 2016,
      y: 1728,
      width: 96,
      height: 96,
    },
    highlevel: {
      x: 2016,
      y: 1824,
      width: 96,
      height: 96,
    },
    highlevel_v2: {
      x: 2016,
      y: 1920,
      width: 96,
      height: 96,
    },
    highnote: {
      x: 0,
      y: 2016,
      width: 96,
      height: 96,
    },
    hive_ai: {
      x: 96,
      y: 2016,
      width: 96,
      height: 96,
    },
    hiveage: {
      x: 192,
      y: 2016,
      width: 96,
      height: 96,
    },
    holded: {
      x: 288,
      y: 2016,
      width: 96,
      height: 96,
    },
    hologram_io: {
      x: 384,
      y: 2016,
      width: 96,
      height: 96,
    },
    home_river_group: {
      x: 480,
      y: 2016,
      width: 96,
      height: 96,
    },
    homebase: {
      x: 672,
      y: 3264,
      width: 96,
      height: 48,
    },
    honeycomb: {
      x: 576,
      y: 2016,
      width: 96,
      height: 96,
    },
    hostfully: {
      x: 672,
      y: 2016,
      width: 96,
      height: 96,
    },
    hotjar: {
      x: 768,
      y: 2016,
      width: 96,
      height: 96,
    },
    hotmart: {
      x: 864,
      y: 2016,
      width: 96,
      height: 96,
    },
    housecall_pro: {
      x: 960,
      y: 2016,
      width: 96,
      height: 96,
    },
    howuku: {
      x: 1056,
      y: 2016,
      width: 96,
      height: 96,
    },
    hrflow: {
      x: 1152,
      y: 2016,
      width: 96,
      height: 96,
    },
    hubilo: {
      x: 1248,
      y: 2016,
      width: 96,
      height: 96,
    },
    hubplanner: {
      x: 1344,
      y: 2016,
      width: 96,
      height: 96,
    },
    hubstaff: {
      x: 1440,
      y: 2016,
      width: 96,
      height: 96,
    },
    hudu: {
      x: 1536,
      y: 2016,
      width: 96,
      height: 96,
    },
    humaans: {
      x: 1632,
      y: 2016,
      width: 96,
      height: 96,
    },
    humanitix: {
      x: 1728,
      y: 2016,
      width: 96,
      height: 96,
    },
    hunter: {
      x: 1824,
      y: 2016,
      width: 96,
      height: 96,
    },
    hypeauditor: {
      x: 1920,
      y: 2016,
      width: 96,
      height: 96,
    },
    hyperswitch: {
      x: 2016,
      y: 2016,
      width: 96,
      height: 96,
    },
    hypertrack: {
      x: 2112,
      y: 0,
      width: 96,
      height: 96,
    },
    icypeas: {
      x: 3358,
      y: 405,
      width: 96,
      height: 18,
    },
    ideanote_io: {
      x: 2112,
      y: 96,
      width: 96,
      height: 96,
    },
    idloom: {
      x: 2112,
      y: 192,
      width: 96,
      height: 96,
    },
    ignitepost: {
      x: 2112,
      y: 288,
      width: 96,
      height: 96,
    },
    illumidesk: {
      x: 2112,
      y: 384,
      width: 96,
      height: 96,
    },
    illumin: {
      x: 2112,
      y: 480,
      width: 96,
      height: 96,
    },
    inbox: {
      x: 2112,
      y: 576,
      width: 96,
      height: 96,
    },
    increase: {
      x: 2112,
      y: 672,
      width: 96,
      height: 96,
    },
    innform: {
      x: 2112,
      y: 768,
      width: 96,
      height: 96,
    },
    innovint_us: {
      x: 2112,
      y: 864,
      width: 96,
      height: 96,
    },
    insightful: {
      x: 2112,
      y: 960,
      width: 96,
      height: 96,
    },
    instamojo: {
      x: 3358,
      y: 23,
      width: 96,
      height: 22,
    },
    instantly_ai: {
      x: 2112,
      y: 1056,
      width: 96,
      height: 96,
    },
    intellihr: {
      x: 2112,
      y: 1152,
      width: 96,
      height: 96,
    },
    interact: {
      x: 2112,
      y: 1248,
      width: 96,
      height: 96,
    },
    intrinio: {
      x: 2591,
      y: 3168,
      width: 96,
      height: 51,
    },
    intruder_io: {
      x: 2112,
      y: 1344,
      width: 96,
      height: 96,
    },
    ipqualityscore: {
      x: 2112,
      y: 1440,
      width: 96,
      height: 96,
    },
    iso_new_england: {
      x: 2112,
      y: 1536,
      width: 96,
      height: 96,
    },
    itempath: {
      x: 2112,
      y: 1632,
      width: 96,
      height: 96,
    },
    jamf_pro: {
      x: 2112,
      y: 1728,
      width: 96,
      height: 96,
    },
    jamf_protect: {
      x: 2112,
      y: 1824,
      width: 96,
      height: 96,
    },
    jasper: {
      x: 2112,
      y: 1920,
      width: 96,
      height: 96,
    },
    jebbit: {
      x: 2112,
      y: 2016,
      width: 96,
      height: 96,
    },
    jestor: {
      x: 0,
      y: 2112,
      width: 96,
      height: 96,
    },
    jira_server: {
      x: 96,
      y: 2112,
      width: 96,
      height: 96,
    },
    jira_service_management: {
      x: 192,
      y: 2112,
      width: 96,
      height: 96,
    },
    jjkeller: {
      x: 288,
      y: 2112,
      width: 96,
      height: 96,
    },
    jobprogress: {
      x: 384,
      y: 2112,
      width: 96,
      height: 96,
    },
    jobscore: {
      x: 480,
      y: 2112,
      width: 96,
      height: 96,
    },
    jobtoolz: {
      x: 576,
      y: 2112,
      width: 96,
      height: 96,
    },
    join: {
      x: 672,
      y: 2112,
      width: 96,
      height: 96,
    },
    joomag: {
      x: 768,
      y: 2112,
      width: 96,
      height: 96,
    },
    journalize: {
      x: 864,
      y: 2112,
      width: 96,
      height: 96,
    },
    journy_io: {
      x: 960,
      y: 2112,
      width: 96,
      height: 96,
    },
    judgeme: {
      x: 1056,
      y: 2112,
      width: 96,
      height: 96,
    },
    jumpcloud: {
      x: 1152,
      y: 2112,
      width: 96,
      height: 96,
    },
    jumpseller: {
      x: 1248,
      y: 2112,
      width: 96,
      height: 96,
    },
    junip: {
      x: 1344,
      y: 2112,
      width: 96,
      height: 96,
    },
    jvzoo: {
      x: 1440,
      y: 2112,
      width: 96,
      height: 96,
    },
    kallidus_sapling: {
      x: 1536,
      y: 2112,
      width: 96,
      height: 96,
    },
    kameleoon: {
      x: 1632,
      y: 2112,
      width: 96,
      height: 96,
    },
    karbon: {
      x: 1440,
      y: 3264,
      width: 96,
      height: 42,
    },
    kargo: {
      x: 1728,
      y: 2112,
      width: 96,
      height: 96,
    },
    kaseya: {
      x: 1824,
      y: 2112,
      width: 96,
      height: 96,
    },
    keap: {
      x: 1056,
      y: 3264,
      width: 96,
      height: 45,
    },
    keap_v2: {
      x: 1920,
      y: 2112,
      width: 96,
      height: 96,
    },
    keen_io: {
      x: 2016,
      y: 2112,
      width: 96,
      height: 96,
    },
    keepcon: {
      x: 2112,
      y: 2112,
      width: 96,
      height: 96,
    },
    kelkoo: {
      x: 1247,
      y: 3168,
      width: 96,
      height: 88,
    },
    kibocommerce: {
      x: 2208,
      y: 0,
      width: 96,
      height: 96,
    },
    kintone: {
      x: 2208,
      y: 96,
      width: 96,
      height: 96,
    },
    kizeo_forms: {
      x: 2208,
      y: 192,
      width: 96,
      height: 96,
    },
    klaus: {
      x: 2208,
      y: 288,
      width: 96,
      height: 96,
    },
    klaviyo_v2: {
      x: 480,
      y: 3314,
      width: 96,
      height: 28,
    },
    knack: {
      x: 2208,
      y: 384,
      width: 96,
      height: 96,
    },
    knocommerce: {
      x: 2208,
      y: 480,
      width: 96,
      height: 96,
    },
    knoema: {
      x: 2208,
      y: 576,
      width: 96,
      height: 96,
    },
    knowbe4_kmsat_reporting: {
      x: 2208,
      y: 672,
      width: 96,
      height: 96,
    },
    knowfirst: {
      x: 2208,
      y: 768,
      width: 96,
      height: 96,
    },
    knowledgeowl: {
      x: 3264,
      y: 96,
      width: 90,
      height: 96,
    },
    kolide: {
      x: 2208,
      y: 864,
      width: 96,
      height: 96,
    },
    konnektive: {
      x: 2208,
      y: 960,
      width: 96,
      height: 96,
    },
    kontak: {
      x: 2208,
      y: 1056,
      width: 96,
      height: 96,
    },
    kontent_ai: {
      x: 2208,
      y: 1152,
      width: 96,
      height: 96,
    },
    kpaehs: {
      x: 2208,
      y: 1248,
      width: 96,
      height: 96,
    },
    kvcore: {
      x: 2208,
      y: 1344,
      width: 96,
      height: 96,
    },
    kyte: {
      x: 2208,
      y: 1440,
      width: 96,
      height: 96,
    },
    lancerkit: {
      x: 2208,
      y: 1536,
      width: 96,
      height: 96,
    },
    landbot: {
      x: 2208,
      y: 1632,
      width: 96,
      height: 96,
    },
    laravel_forge: {
      x: 2208,
      y: 1728,
      width: 96,
      height: 96,
    },
    layup: {
      x: 2208,
      y: 1824,
      width: 96,
      height: 96,
    },
    leaddyno: {
      x: 2208,
      y: 1920,
      width: 96,
      height: 96,
    },
    leadfeeder: {
      x: 2208,
      y: 2016,
      width: 96,
      height: 96,
    },
    leadspedia: {
      x: 2208,
      y: 2112,
      width: 96,
      height: 96,
    },
    leadsquared: {
      x: 0,
      y: 2208,
      width: 96,
      height: 96,
    },
    leadsrx: {
      x: 96,
      y: 2208,
      width: 96,
      height: 96,
    },
    leaflink: {
      x: 3071,
      y: 3168,
      width: 96,
      height: 50,
    },
    leap: {
      x: 192,
      y: 2208,
      width: 96,
      height: 96,
    },
    lemon_markets: {
      x: 288,
      y: 2208,
      width: 96,
      height: 96,
    },
    lemon_squeezy: {
      x: 384,
      y: 2208,
      width: 96,
      height: 96,
    },
    lendapi: {
      x: 2400,
      y: 3314,
      width: 96,
      height: 24,
    },
    leverade: {
      x: 480,
      y: 2208,
      width: 96,
      height: 96,
    },
    lexoffice: {
      x: 576,
      y: 2208,
      width: 96,
      height: 96,
    },
    limblecmms: {
      x: 1151,
      y: 3168,
      width: 96,
      height: 93,
    },
    linearb: {
      x: 672,
      y: 2208,
      width: 96,
      height: 96,
    },
    lineup: {
      x: 768,
      y: 2208,
      width: 96,
      height: 96,
    },
    linkace: {
      x: 864,
      y: 2208,
      width: 96,
      height: 96,
    },
    listclean: {
      x: 960,
      y: 2208,
      width: 96,
      height: 96,
    },
    listen_notes: {
      x: 1056,
      y: 2208,
      width: 96,
      height: 96,
    },
    listrak_email: {
      x: 1152,
      y: 2208,
      width: 96,
      height: 96,
    },
    listrak_sms: {
      x: 1248,
      y: 2208,
      width: 96,
      height: 96,
    },
    little_green_light: {
      x: 1344,
      y: 2208,
      width: 96,
      height: 96,
    },
    liveagent: {
      x: 1440,
      y: 2208,
      width: 96,
      height: 96,
    },
    livesession: {
      x: 1536,
      y: 2208,
      width: 96,
      height: 96,
    },
    livestorm: {
      x: 768,
      y: 3168,
      width: 95,
      height: 96,
    },
    livingdocs_io: {
      x: 1632,
      y: 2208,
      width: 96,
      height: 96,
    },
    local_falcon: {
      x: 1728,
      y: 2208,
      width: 96,
      height: 96,
    },
    localazy: {
      x: 1824,
      y: 2208,
      width: 96,
      height: 96,
    },
    lodgify: {
      x: 1920,
      y: 2208,
      width: 96,
      height: 96,
    },
    lokalise: {
      x: 2496,
      y: 3314,
      width: 96,
      height: 24,
    },
    loops_so: {
      x: 2016,
      y: 2208,
      width: 96,
      height: 96,
    },
    loopwork_co: {
      x: 576,
      y: 3314,
      width: 96,
      height: 28,
    },
    loyjoy: {
      x: 2112,
      y: 2208,
      width: 96,
      height: 96,
    },
    loyverse: {
      x: 2208,
      y: 2208,
      width: 96,
      height: 96,
    },
    lucidya: {
      x: 2304,
      y: 0,
      width: 96,
      height: 96,
    },
    lunatask: {
      x: 2304,
      y: 96,
      width: 96,
      height: 96,
    },
    maestra: {
      x: 2304,
      y: 192,
      width: 96,
      height: 96,
    },
    maestroqa: {
      x: 2304,
      y: 288,
      width: 96,
      height: 96,
    },
    magicplan: {
      x: 3358,
      y: 232,
      width: 96,
      height: 20,
    },
    mailblaze: {
      x: 1824,
      y: 3264,
      width: 96,
      height: 39,
    },
    mailercheck: {
      x: 2304,
      y: 384,
      width: 96,
      height: 96,
    },
    mailersend: {
      x: 2304,
      y: 480,
      width: 96,
      height: 96,
    },
    mailify: {
      x: 2304,
      y: 576,
      width: 96,
      height: 96,
    },
    mailinabox: {
      x: 2304,
      y: 672,
      width: 96,
      height: 96,
    },
    mailosaur: {
      x: 2304,
      y: 768,
      width: 96,
      height: 96,
    },
    mailsac: {
      x: 2304,
      y: 864,
      width: 96,
      height: 96,
    },
    mailshake: {
      x: 2304,
      y: 960,
      width: 96,
      height: 96,
    },
    mailslurp: {
      x: 2304,
      y: 1056,
      width: 96,
      height: 96,
    },
    mailsoftly: {
      x: 2304,
      y: 1152,
      width: 96,
      height: 96,
    },
    maintainx: {
      x: 2304,
      y: 1248,
      width: 96,
      height: 96,
    },
    mainwp: {
      x: 2304,
      y: 1344,
      width: 96,
      height: 96,
    },
    makeplans: {
      x: 2304,
      y: 1440,
      width: 96,
      height: 96,
    },
    manatal: {
      x: 2304,
      y: 1536,
      width: 96,
      height: 96,
    },
    manychat: {
      x: 2304,
      y: 1632,
      width: 96,
      height: 96,
    },
    mapulus: {
      x: 2304,
      y: 1728,
      width: 96,
      height: 96,
    },
    marchex: {
      x: 2304,
      y: 1824,
      width: 96,
      height: 96,
    },
    marketaux: {
      x: 2304,
      y: 1920,
      width: 96,
      height: 96,
    },
    maropost: {
      x: 2304,
      y: 2016,
      width: 96,
      height: 96,
    },
    mattermark: {
      x: 2304,
      y: 2112,
      width: 96,
      height: 96,
    },
    mattermost: {
      x: 2304,
      y: 2208,
      width: 96,
      height: 96,
    },
    mautic: {
      x: 0,
      y: 2304,
      width: 96,
      height: 96,
    },
    mav: {
      x: 96,
      y: 2304,
      width: 96,
      height: 96,
    },
    mcleod_software: {
      x: 192,
      y: 2304,
      width: 96,
      height: 96,
    },
    mediasilo: {
      x: 288,
      y: 2304,
      width: 96,
      height: 96,
    },
    medium: {
      x: 384,
      y: 2304,
      width: 96,
      height: 96,
    },
    medusa: {
      x: 480,
      y: 2304,
      width: 96,
      height: 96,
    },
    meetingpulse: {
      x: 576,
      y: 2304,
      width: 96,
      height: 96,
    },
    megaventory: {
      x: 672,
      y: 2304,
      width: 96,
      height: 96,
    },
    meld_io: {
      x: 1632,
      y: 3264,
      width: 96,
      height: 40,
    },
    melo: {
      x: 768,
      y: 2304,
      width: 96,
      height: 96,
    },
    memberstack: {
      x: 864,
      y: 2304,
      width: 96,
      height: 96,
    },
    meraki: {
      x: 1631,
      y: 3168,
      width: 96,
      height: 77,
    },
    merchant_spring: {
      x: 960,
      y: 2304,
      width: 96,
      height: 96,
    },
    mercury: {
      x: 1056,
      y: 2304,
      width: 96,
      height: 96,
    },
    messageflow: {
      x: 1152,
      y: 2304,
      width: 96,
      height: 96,
    },
    messari_io: {
      x: 1248,
      y: 2304,
      width: 96,
      height: 96,
    },
    metaplane: {
      x: 1344,
      y: 2304,
      width: 96,
      height: 96,
    },
    metatext: {
      x: 1440,
      y: 2304,
      width: 96,
      height: 96,
    },
    metrc: {
      x: 1536,
      y: 2304,
      width: 96,
      height: 96,
    },
    metricool: {
      x: 1632,
      y: 2304,
      width: 96,
      height: 96,
    },
    microsoft_app_store: {
      x: 1728,
      y: 2304,
      width: 96,
      height: 96,
    },
    microsoft_graph: {
      x: 864,
      y: 3264,
      width: 96,
      height: 47,
    },
    microsoft_sharepoint_excel: {
      x: 1824,
      y: 2304,
      width: 96,
      height: 96,
    },
    middesk: {
      x: 1920,
      y: 2304,
      width: 96,
      height: 96,
    },
    mindbody: {
      x: 2016,
      y: 2304,
      width: 96,
      height: 96,
    },
    minutemailer: {
      x: 2112,
      y: 2304,
      width: 96,
      height: 96,
    },
    mnemonic: {
      x: 2208,
      y: 2304,
      width: 96,
      height: 96,
    },
    mobile_action: {
      x: 2304,
      y: 2304,
      width: 96,
      height: 96,
    },
    modash_io: {
      x: 2400,
      y: 0,
      width: 96,
      height: 96,
    },
    modrinth: {
      x: 2400,
      y: 96,
      width: 96,
      height: 96,
    },
    modusign: {
      x: 2400,
      y: 192,
      width: 96,
      height: 96,
    },
    moego: {
      x: 2400,
      y: 288,
      width: 96,
      height: 96,
    },
    mollie: {
      x: 2400,
      y: 384,
      width: 96,
      height: 96,
    },
    moneybird: {
      x: 2400,
      y: 480,
      width: 96,
      height: 96,
    },
    monkeylearn: {
      x: 2400,
      y: 576,
      width: 96,
      height: 96,
    },
    monnify: {
      x: 3358,
      y: 458,
      width: 96,
      height: 17,
    },
    moodys: {
      x: 2400,
      y: 672,
      width: 96,
      height: 96,
    },
    moonclerk: {
      x: 2400,
      y: 768,
      width: 96,
      height: 96,
    },
    moonmail: {
      x: 2400,
      y: 864,
      width: 96,
      height: 96,
    },
    moosend: {
      x: 2400,
      y: 960,
      width: 96,
      height: 96,
    },
    motiontools: {
      x: 2400,
      y: 1056,
      width: 96,
      height: 96,
    },
    mrpeasy: {
      x: 2400,
      y: 1152,
      width: 96,
      height: 96,
    },
    msuite: {
      x: 2400,
      y: 1248,
      width: 96,
      height: 96,
    },
    myclub: {
      x: 2400,
      y: 1344,
      width: 96,
      height: 96,
    },
    mydevices: {
      x: 2400,
      y: 1440,
      width: 96,
      height: 96,
    },
    myemma: {
      x: 2400,
      y: 1536,
      width: 96,
      height: 96,
    },
    mytime: {
      x: 2400,
      y: 1632,
      width: 96,
      height: 96,
    },
    n8n: {
      x: 2400,
      y: 1728,
      width: 96,
      height: 96,
    },
    nabis: {
      x: 2400,
      y: 1824,
      width: 96,
      height: 96,
    },
    national_park_service: {
      x: 2400,
      y: 1920,
      width: 96,
      height: 96,
    },
    ncdc: {
      x: 2400,
      y: 2016,
      width: 96,
      height: 96,
    },
    ncr: {
      x: 2400,
      y: 2112,
      width: 96,
      height: 96,
    },
    ncreif: {
      x: 2400,
      y: 2208,
      width: 96,
      height: 96,
    },
    ncreif_query: {
      x: 2400,
      y: 2304,
      width: 96,
      height: 96,
    },
    ncscale: {
      x: 0,
      y: 2400,
      width: 96,
      height: 96,
    },
    neoncrm: {
      x: 96,
      y: 2400,
      width: 96,
      height: 96,
    },
    neonpixel: {
      x: 192,
      y: 2400,
      width: 96,
      height: 96,
    },
    neverbounce: {
      x: 288,
      y: 2400,
      width: 96,
      height: 96,
    },
    new_relic: {
      x: 3358,
      y: 475,
      width: 96,
      height: 17,
    },
    news_api: {
      x: 384,
      y: 2400,
      width: 96,
      height: 96,
    },
    newscred: {
      x: 480,
      y: 2400,
      width: 96,
      height: 96,
    },
    nicereply: {
      x: 576,
      y: 2400,
      width: 96,
      height: 96,
    },
    nifty: {
      x: 672,
      y: 2400,
      width: 96,
      height: 96,
    },
    nifty_images: {
      x: 3264,
      y: 576,
      width: 66,
      height: 96,
    },
    nimble: {
      x: 768,
      y: 2400,
      width: 96,
      height: 96,
    },
    nimbleway: {
      x: 864,
      y: 2400,
      width: 96,
      height: 96,
    },
    nist: {
      x: 960,
      y: 2400,
      width: 96,
      height: 96,
    },
    nmap: {
      x: 1056,
      y: 2400,
      width: 96,
      height: 96,
    },
    nmkr: {
      x: 1152,
      y: 2400,
      width: 96,
      height: 96,
    },
    nomad: {
      x: 3264,
      y: 288,
      width: 78,
      height: 96,
    },
    northbeam: {
      x: 1248,
      y: 2400,
      width: 96,
      height: 96,
    },
    nrel_gov: {
      x: 1344,
      y: 2400,
      width: 96,
      height: 96,
    },
    nue: {
      x: 1440,
      y: 2400,
      width: 96,
      height: 96,
    },
    nutshell: {
      x: 3358,
      y: 570,
      width: 96,
      height: 14,
    },
    nuviad: {
      x: 1536,
      y: 2400,
      width: 96,
      height: 96,
    },
    nyckel: {
      x: 96,
      y: 3314,
      width: 96,
      height: 30,
    },
    observe_ai: {
      x: 1632,
      y: 2400,
      width: 96,
      height: 96,
    },
    ofac: {
      x: 1728,
      y: 2400,
      width: 96,
      height: 96,
    },
    offerslook: {
      x: 1824,
      y: 2400,
      width: 96,
      height: 96,
    },
    officernd_flex: {
      x: 1920,
      y: 2400,
      width: 96,
      height: 96,
    },
    officernd_hybrid: {
      x: 2016,
      y: 2400,
      width: 96,
      height: 96,
    },
    oktopost: {
      x: 2112,
      y: 2400,
      width: 96,
      height: 96,
    },
    ometria_email_events: {
      x: 2208,
      y: 2400,
      width: 96,
      height: 96,
    },
    omnisend: {
      x: 2304,
      y: 2400,
      width: 96,
      height: 96,
    },
    omnitracs: {
      x: 2400,
      y: 2400,
      width: 96,
      height: 96,
    },
    onboard: {
      x: 2496,
      y: 0,
      width: 96,
      height: 96,
    },
    onesignal: {
      x: 2496,
      y: 96,
      width: 96,
      height: 96,
    },
    onfleet: {
      x: 2496,
      y: 192,
      width: 96,
      height: 96,
    },
    onpay: {
      x: 2496,
      y: 288,
      width: 96,
      height: 96,
    },
    ontraport: {
      x: 3358,
      y: 555,
      width: 96,
      height: 15,
    },
    openscreen: {
      x: 2496,
      y: 384,
      width: 96,
      height: 96,
    },
    optimoroute: {
      x: 2496,
      y: 480,
      width: 96,
      height: 96,
    },
    optmyzr: {
      x: 2496,
      y: 576,
      width: 96,
      height: 96,
    },
    oracle_fusion_epm: {
      x: 2496,
      y: 672,
      width: 96,
      height: 96,
    },
    oracle_fusion_erp: {
      x: 2496,
      y: 768,
      width: 96,
      height: 96,
    },
    oracle_fusion_hcm: {
      x: 2496,
      y: 864,
      width: 96,
      height: 96,
    },
    oracle_fusion_ofs: {
      x: 2496,
      y: 960,
      width: 96,
      height: 96,
    },
    oracle_fusion_wms: {
      x: 2496,
      y: 1056,
      width: 96,
      height: 96,
    },
    oracle_primavera_cloud: {
      x: 2496,
      y: 1152,
      width: 96,
      height: 96,
    },
    order_time: {
      x: 2496,
      y: 1248,
      width: 96,
      height: 96,
    },
    orderdesk: {
      x: 2496,
      y: 1344,
      width: 96,
      height: 96,
    },
    orderful: {
      x: 2496,
      y: 1440,
      width: 96,
      height: 96,
    },
    ordermate_io: {
      x: 2496,
      y: 1536,
      width: 96,
      height: 96,
    },
    orderspace: {
      x: 2496,
      y: 1632,
      width: 96,
      height: 96,
    },
    outline: {
      x: 2496,
      y: 1728,
      width: 96,
      height: 96,
    },
    outscraper: {
      x: 2496,
      y: 1824,
      width: 96,
      height: 96,
    },
    outseta: {
      x: 2496,
      y: 1920,
      width: 96,
      height: 96,
    },
    oxford_economics: {
      x: 2496,
      y: 2016,
      width: 96,
      height: 96,
    },
    oxylabs_io: {
      x: 3264,
      y: 384,
      width: 72,
      height: 96,
    },
    pabbly_email_marketing: {
      x: 2496,
      y: 2112,
      width: 96,
      height: 96,
    },
    packagex: {
      x: 2496,
      y: 2208,
      width: 96,
      height: 96,
    },
    paigo: {
      x: 2496,
      y: 2304,
      width: 96,
      height: 96,
    },
    palantir_foundry: {
      x: 2496,
      y: 2400,
      width: 96,
      height: 96,
    },
    paperform: {
      x: 0,
      y: 2496,
      width: 96,
      height: 96,
    },
    papersurvey: {
      x: 96,
      y: 2496,
      width: 96,
      height: 96,
    },
    parcellab: {
      x: 192,
      y: 2496,
      width: 96,
      height: 96,
    },
    paychex_time: {
      x: 288,
      y: 2496,
      width: 96,
      height: 96,
    },
    paycor: {
      x: 384,
      y: 2496,
      width: 96,
      height: 96,
    },
    payhere: {
      x: 480,
      y: 2496,
      width: 96,
      height: 96,
    },
    paystack: {
      x: 576,
      y: 2496,
      width: 96,
      height: 96,
    },
    peakon: {
      x: 672,
      y: 2496,
      width: 96,
      height: 96,
    },
    peloton: {
      x: 1152,
      y: 3264,
      width: 96,
      height: 44,
    },
    pencil_spaces: {
      x: 768,
      y: 2496,
      width: 96,
      height: 96,
    },
    pennylane: {
      x: 864,
      y: 2496,
      width: 96,
      height: 96,
    },
    pensionpro: {
      x: 960,
      y: 2496,
      width: 96,
      height: 96,
    },
    pepperjam: {
      x: 2976,
      y: 3314,
      width: 96,
      height: 23,
    },
    perceptyx: {
      x: 1056,
      y: 2496,
      width: 96,
      height: 96,
    },
    persistiq: {
      x: 1152,
      y: 2496,
      width: 96,
      height: 96,
    },
    pexels: {
      x: 1248,
      y: 2496,
      width: 96,
      height: 96,
    },
    phantombuster: {
      x: 1344,
      y: 2496,
      width: 96,
      height: 96,
    },
    pheedloop: {
      x: 1440,
      y: 2496,
      width: 96,
      height: 96,
    },
    piano: {
      x: 1536,
      y: 2496,
      width: 96,
      height: 96,
    },
    pinecone: {
      x: 1632,
      y: 2496,
      width: 96,
      height: 96,
    },
    pingbell: {
      x: 1728,
      y: 2496,
      width: 96,
      height: 96,
    },
    pingboard: {
      x: 1823,
      y: 3168,
      width: 96,
      height: 72,
    },
    pipelinecrm: {
      x: 1824,
      y: 2496,
      width: 96,
      height: 96,
    },
    pipeliner: {
      x: 1920,
      y: 2496,
      width: 96,
      height: 96,
    },
    pitchbox: {
      x: 2016,
      y: 2496,
      width: 96,
      height: 96,
    },
    plaid: {
      x: 2592,
      y: 3264,
      width: 96,
      height: 37,
    },
    planet: {
      x: 768,
      y: 3264,
      width: 96,
      height: 48,
    },
    plausible: {
      x: 1824,
      y: 3314,
      width: 96,
      height: 25,
    },
    pledge: {
      x: 2112,
      y: 2496,
      width: 96,
      height: 96,
    },
    plezi: {
      x: 2208,
      y: 2496,
      width: 96,
      height: 96,
    },
    plivo: {
      x: 2304,
      y: 2496,
      width: 96,
      height: 96,
    },
    plugandpay: {
      x: 2208,
      y: 3264,
      width: 96,
      height: 38,
    },
    plugnpaid: {
      x: 2400,
      y: 2496,
      width: 96,
      height: 96,
    },
    pluralsight: {
      x: 2496,
      y: 2496,
      width: 96,
      height: 96,
    },
    podium: {
      x: 2592,
      y: 0,
      width: 96,
      height: 96,
    },
    pointagram: {
      x: 2592,
      y: 96,
      width: 96,
      height: 96,
    },
    pointerpro: {
      x: 2592,
      y: 192,
      width: 96,
      height: 96,
    },
    polygon_io: {
      x: 2592,
      y: 288,
      width: 96,
      height: 96,
    },
    ponto: {
      x: 3167,
      y: 3168,
      width: 96,
      height: 50,
    },
    popl: {
      x: 2592,
      y: 384,
      width: 96,
      height: 96,
    },
    portable: {
      x: 2592,
      y: 480,
      width: 96,
      height: 96,
    },
    portable_admin: {
      x: 2592,
      y: 576,
      width: 96,
      height: 96,
    },
    portable_coding_agent: {
      x: 2592,
      y: 672,
      width: 96,
      height: 96,
    },
    portaone: {
      x: 2592,
      y: 768,
      width: 96,
      height: 96,
    },
    post_cheetah: {
      x: 3264,
      y: 0,
      width: 94,
      height: 96,
    },
    postalytics: {
      x: 2592,
      y: 864,
      width: 96,
      height: 96,
    },
    postgrid: {
      x: 2592,
      y: 960,
      width: 96,
      height: 96,
    },
    postscript_io: {
      x: 2592,
      y: 1056,
      width: 96,
      height: 96,
    },
    postup: {
      x: 2592,
      y: 1152,
      width: 96,
      height: 96,
    },
    practice_better: {
      x: 2592,
      y: 1248,
      width: 96,
      height: 96,
    },
    precisefp: {
      x: 2592,
      y: 1344,
      width: 96,
      height: 96,
    },
    predicthq: {
      x: 2592,
      y: 1440,
      width: 96,
      height: 96,
    },
    prefinery: {
      x: 2592,
      y: 1536,
      width: 96,
      height: 96,
    },
    priceblocs: {
      x: 2592,
      y: 1632,
      width: 96,
      height: 96,
    },
    pricehubble: {
      x: 2592,
      y: 1728,
      width: 96,
      height: 96,
    },
    printbox: {
      x: 3072,
      y: 3314,
      width: 96,
      height: 23,
    },
    printfection: {
      x: 2592,
      y: 1824,
      width: 96,
      height: 96,
    },
    private_ai: {
      x: 2592,
      y: 1920,
      width: 96,
      height: 96,
    },
    process_street: {
      x: 2592,
      y: 2016,
      width: 96,
      height: 96,
    },
    proda_ai: {
      x: 2592,
      y: 2112,
      width: 96,
      height: 96,
    },
    prodpad: {
      x: 2592,
      y: 2208,
      width: 96,
      height: 96,
    },
    productlane: {
      x: 2592,
      y: 2304,
      width: 96,
      height: 96,
    },
    productplan: {
      x: 2592,
      y: 2400,
      width: 96,
      height: 96,
    },
    productsup: {
      x: 2592,
      y: 2496,
      width: 96,
      height: 96,
    },
    profitsage: {
      x: 0,
      y: 2592,
      width: 96,
      height: 96,
    },
    profitwell: {
      x: 96,
      y: 2592,
      width: 96,
      height: 96,
    },
    promptmate: {
      x: 192,
      y: 2592,
      width: 96,
      height: 96,
    },
    proof: {
      x: 288,
      y: 2592,
      width: 96,
      height: 96,
    },
    proofserve: {
      x: 384,
      y: 2592,
      width: 96,
      height: 96,
    },
    propexo: {
      x: 864,
      y: 3314,
      width: 96,
      height: 27,
    },
    proprofs_project: {
      x: 480,
      y: 2592,
      width: 96,
      height: 96,
    },
    proxiedmail: {
      x: 576,
      y: 2592,
      width: 96,
      height: 96,
    },
    proz: {
      x: 672,
      y: 2592,
      width: 96,
      height: 96,
    },
    publisherkit: {
      x: 768,
      y: 2592,
      width: 96,
      height: 96,
    },
    pulse: {
      x: 864,
      y: 2592,
      width: 96,
      height: 96,
    },
    pulse_grow: {
      x: 960,
      y: 2592,
      width: 96,
      height: 96,
    },
    pumble: {
      x: 1920,
      y: 3314,
      width: 96,
      height: 25,
    },
    pushcut: {
      x: 1056,
      y: 2592,
      width: 96,
      height: 96,
    },
    pwc_investor_survey: {
      x: 1152,
      y: 2592,
      width: 96,
      height: 96,
    },
    qdrant: {
      x: 1248,
      y: 2592,
      width: 96,
      height: 96,
    },
    qminder: {
      x: 2303,
      y: 3168,
      width: 96,
      height: 54,
    },
    qolopay: {
      x: 1344,
      y: 2592,
      width: 96,
      height: 96,
    },
    qonto: {
      x: 1440,
      y: 2592,
      width: 96,
      height: 96,
    },
    qoyod: {
      x: 1536,
      y: 2592,
      width: 96,
      height: 96,
    },
    quaderno: {
      x: 1632,
      y: 2592,
      width: 96,
      height: 96,
    },
    qualified_io: {
      x: 1728,
      y: 2592,
      width: 96,
      height: 96,
    },
    qubeyond: {
      x: 1824,
      y: 2592,
      width: 96,
      height: 96,
    },
    quickbase: {
      x: 3358,
      y: 492,
      width: 96,
      height: 16,
    },
    quickbooks_reports: {
      x: 1920,
      y: 2592,
      width: 96,
      height: 96,
    },
    quotapath: {
      x: 2016,
      y: 2592,
      width: 96,
      height: 96,
    },
    qwilr: {
      x: 2112,
      y: 2592,
      width: 96,
      height: 96,
    },
    radar: {
      x: 2208,
      y: 2592,
      width: 96,
      height: 96,
    },
    radio_co: {
      x: 2304,
      y: 2592,
      width: 96,
      height: 96,
    },
    raisedonors: {
      x: 2400,
      y: 2592,
      width: 96,
      height: 96,
    },
    raisely: {
      x: 2496,
      y: 2592,
      width: 96,
      height: 96,
    },
    range: {
      x: 2592,
      y: 2592,
      width: 96,
      height: 96,
    },
    range_co: {
      x: 2688,
      y: 0,
      width: 96,
      height: 96,
    },
    rapid7: {
      x: 2688,
      y: 96,
      width: 96,
      height: 96,
    },
    rapidpro_io: {
      x: 2688,
      y: 192,
      width: 96,
      height: 96,
    },
    raventools: {
      x: 2688,
      y: 288,
      width: 96,
      height: 96,
    },
    razorpay: {
      x: 2688,
      y: 384,
      width: 96,
      height: 96,
    },
    reachinbox: {
      x: 3358,
      y: 423,
      width: 96,
      height: 18,
    },
    realgreen: {
      x: 2688,
      y: 480,
      width: 96,
      height: 96,
    },
    realhub: {
      x: 2688,
      y: 576,
      width: 96,
      height: 96,
    },
    reamaze: {
      x: 2688,
      y: 672,
      width: 96,
      height: 96,
    },
    rebrandly: {
      x: 2688,
      y: 768,
      width: 96,
      height: 96,
    },
    recreation_gov: {
      x: 2688,
      y: 864,
      width: 96,
      height: 96,
    },
    recruit_crm: {
      x: 2688,
      y: 960,
      width: 96,
      height: 96,
    },
    recruitee: {
      x: 1919,
      y: 3168,
      width: 96,
      height: 63,
    },
    recruiterflow: {
      x: 2688,
      y: 1056,
      width: 96,
      height: 96,
    },
    redtrackio: {
      x: 2688,
      y: 1152,
      width: 96,
      height: 96,
    },
    reductstore: {
      x: 2688,
      y: 1248,
      width: 96,
      height: 96,
    },
    reepay: {
      x: 2688,
      y: 1344,
      width: 96,
      height: 96,
    },
    refdataco: {
      x: 672,
      y: 3314,
      width: 96,
      height: 28,
    },
    referral_rock: {
      x: 2688,
      y: 1440,
      width: 96,
      height: 96,
    },
    referrizer: {
      x: 2688,
      y: 1536,
      width: 96,
      height: 96,
    },
    refersion: {
      x: 2688,
      y: 1632,
      width: 96,
      height: 96,
    },
    reflect: {
      x: 2688,
      y: 1728,
      width: 96,
      height: 96,
    },
    rejoiner: {
      x: 2688,
      y: 1824,
      width: 96,
      height: 96,
    },
    relavate: {
      x: 3168,
      y: 3314,
      width: 96,
      height: 23,
    },
    relevance_ai: {
      x: 2688,
      y: 1920,
      width: 96,
      height: 96,
    },
    reloadly: {
      x: 2688,
      y: 2016,
      width: 96,
      height: 96,
    },
    remarkety: {
      x: 2688,
      y: 2112,
      width: 96,
      height: 96,
    },
    renderform_io: {
      x: 2688,
      y: 2208,
      width: 96,
      height: 96,
    },
    rentcast: {
      x: 2688,
      y: 2304,
      width: 96,
      height: 96,
    },
    rently: {
      x: 2688,
      y: 2400,
      width: 96,
      height: 96,
    },
    repliq: {
      x: 2688,
      y: 2496,
      width: 96,
      height: 96,
    },
    replyify: {
      x: 2688,
      y: 2592,
      width: 96,
      height: 96,
    },
    repsly: {
      x: 0,
      y: 2688,
      width: 96,
      height: 96,
    },
    reputation: {
      x: 96,
      y: 2688,
      width: 96,
      height: 96,
    },
    respond_io: {
      x: 192,
      y: 2688,
      width: 96,
      height: 96,
    },
    restaurant365: {
      x: 288,
      y: 2688,
      width: 96,
      height: 96,
    },
    retable: {
      x: 3358,
      y: 252,
      width: 96,
      height: 20,
    },
    reteach: {
      x: 384,
      y: 2688,
      width: 96,
      height: 96,
    },
    reteno: {
      x: 480,
      y: 2688,
      width: 96,
      height: 96,
    },
    retool: {
      x: 0,
      y: 3264,
      width: 96,
      height: 50,
    },
    retriever: {
      x: 576,
      y: 2688,
      width: 96,
      height: 96,
    },
    returngo: {
      x: 672,
      y: 2688,
      width: 96,
      height: 96,
    },
    returnless: {
      x: 768,
      y: 2688,
      width: 96,
      height: 96,
    },
    returnlogic: {
      x: 864,
      y: 2688,
      width: 96,
      height: 96,
    },
    returnly: {
      x: 960,
      y: 2688,
      width: 96,
      height: 96,
    },
    rev: {
      x: 1056,
      y: 2688,
      width: 96,
      height: 96,
    },
    revcontent: {
      x: 1152,
      y: 2688,
      width: 96,
      height: 96,
    },
    revi_io: {
      x: 1248,
      y: 2688,
      width: 96,
      height: 96,
    },
    reviewflowz: {
      x: 1344,
      y: 2688,
      width: 96,
      height: 96,
    },
    reviews: {
      x: 1440,
      y: 2688,
      width: 96,
      height: 96,
    },
    revolut_merchant: {
      x: 3358,
      y: 45,
      width: 96,
      height: 22,
    },
    rezdy: {
      x: 1536,
      y: 2688,
      width: 96,
      height: 96,
    },
    rhythm: {
      x: 1632,
      y: 2688,
      width: 96,
      height: 96,
    },
    rilla: {
      x: 1728,
      y: 2688,
      width: 96,
      height: 96,
    },
    rise: {
      x: 1824,
      y: 2688,
      width: 96,
      height: 96,
    },
    rise_ai: {
      x: 1920,
      y: 2688,
      width: 96,
      height: 96,
    },
    riskadvisor: {
      x: 2016,
      y: 2688,
      width: 96,
      height: 96,
    },
    roam_ai: {
      x: 2112,
      y: 2688,
      width: 96,
      height: 96,
    },
    roboflow: {
      x: 2208,
      y: 2688,
      width: 96,
      height: 96,
    },
    rocketreach: {
      x: 2304,
      y: 2688,
      width: 96,
      height: 96,
    },
    rotessa: {
      x: 2400,
      y: 2688,
      width: 96,
      height: 96,
    },
    routelogic: {
      x: 2496,
      y: 2688,
      width: 96,
      height: 96,
    },
    rudder: {
      x: 2592,
      y: 2688,
      width: 96,
      height: 96,
    },
    runa_io: {
      x: 2304,
      y: 3264,
      width: 96,
      height: 38,
    },
    ryver: {
      x: 2688,
      y: 2688,
      width: 96,
      height: 96,
    },
    sailpoint: {
      x: 2784,
      y: 0,
      width: 96,
      height: 96,
    },
    salesflare: {
      x: 2784,
      y: 96,
      width: 96,
      height: 96,
    },
    salesmachine: {
      x: 2784,
      y: 192,
      width: 96,
      height: 96,
    },
    salesmanager: {
      x: 3358,
      y: 0,
      width: 96,
      height: 23,
    },
    salesmanago: {
      x: 2784,
      y: 288,
      width: 96,
      height: 96,
    },
    salesmate: {
      x: 2784,
      y: 384,
      width: 96,
      height: 96,
    },
    salespanel_io: {
      x: 2784,
      y: 480,
      width: 96,
      height: 96,
    },
    salesrabbit: {
      x: 2784,
      y: 576,
      width: 96,
      height: 96,
    },
    samcart: {
      x: 2784,
      y: 672,
      width: 96,
      height: 96,
    },
    sarbacane: {
      x: 2784,
      y: 768,
      width: 96,
      height: 96,
    },
    satismeter: {
      x: 2784,
      y: 864,
      width: 96,
      height: 96,
    },
    savvycal: {
      x: 2784,
      y: 960,
      width: 96,
      height: 96,
    },
    scalefusion: {
      x: 2784,
      y: 1056,
      width: 96,
      height: 96,
    },
    scalyr: {
      x: 2784,
      y: 1152,
      width: 96,
      height: 96,
    },
    scanifly: {
      x: 2784,
      y: 1248,
      width: 96,
      height: 96,
    },
    scarf_sh: {
      x: 2784,
      y: 1344,
      width: 96,
      height: 96,
    },
    scenes: {
      x: 2784,
      y: 1440,
      width: 96,
      height: 96,
    },
    scout_apm: {
      x: 2784,
      y: 1536,
      width: 96,
      height: 96,
    },
    scout_talent: {
      x: 2784,
      y: 1632,
      width: 96,
      height: 96,
    },
    screendesk: {
      x: 2784,
      y: 1728,
      width: 96,
      height: 96,
    },
    scribeless: {
      x: 2784,
      y: 1824,
      width: 96,
      height: 96,
    },
    search_io: {
      x: 2784,
      y: 1920,
      width: 96,
      height: 96,
    },
    secoda: {
      x: 2784,
      y: 2016,
      width: 96,
      height: 96,
    },
    seidat: {
      x: 2784,
      y: 2112,
      width: 96,
      height: 96,
    },
    sellbrite: {
      x: 2784,
      y: 2208,
      width: 96,
      height: 96,
    },
    sellerchamp: {
      x: 2784,
      y: 2304,
      width: 96,
      height: 96,
    },
    sellix: {
      x: 960,
      y: 3314,
      width: 96,
      height: 27,
    },
    senar: {
      x: 2784,
      y: 2400,
      width: 96,
      height: 96,
    },
    sendbird: {
      x: 2784,
      y: 2496,
      width: 96,
      height: 96,
    },
    sender: {
      x: 2784,
      y: 2592,
      width: 96,
      height: 96,
    },
    sendlane: {
      x: 2784,
      y: 2688,
      width: 96,
      height: 96,
    },
    sendowl: {
      x: 0,
      y: 2784,
      width: 96,
      height: 96,
    },
    sendpulse: {
      x: 96,
      y: 2784,
      width: 96,
      height: 96,
    },
    sendwithus: {
      x: 192,
      y: 2784,
      width: 96,
      height: 96,
    },
    senja: {
      x: 288,
      y: 2784,
      width: 96,
      height: 96,
    },
    sensor_industries: {
      x: 384,
      y: 2784,
      width: 96,
      height: 96,
    },
    sertifier: {
      x: 480,
      y: 2784,
      width: 96,
      height: 96,
    },
    servicefusion: {
      x: 576,
      y: 2784,
      width: 96,
      height: 96,
    },
    seven: {
      x: 672,
      y: 2784,
      width: 96,
      height: 96,
    },
    sevenrooms: {
      x: 768,
      y: 2784,
      width: 96,
      height: 96,
    },
    sharpspring: {
      x: 864,
      y: 2784,
      width: 96,
      height: 96,
    },
    shift4: {
      x: 3358,
      y: 272,
      width: 96,
      height: 20,
    },
    ship_compliant: {
      x: 960,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipbob: {
      x: 1056,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipcloud: {
      x: 1152,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipday: {
      x: 1248,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipengine: {
      x: 1344,
      y: 2784,
      width: 96,
      height: 96,
    },
    shiphawk: {
      x: 1440,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipmondo: {
      x: 1536,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipmonk: {
      x: 1632,
      y: 2784,
      width: 96,
      height: 96,
    },
    shippo: {
      x: 1728,
      y: 2784,
      width: 96,
      height: 96,
    },
    shippypro: {
      x: 1824,
      y: 2784,
      width: 96,
      height: 96,
    },
    shiptime: {
      x: 1920,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipwire: {
      x: 2016,
      y: 2784,
      width: 96,
      height: 96,
    },
    shipyardapp: {
      x: 2112,
      y: 2784,
      width: 96,
      height: 96,
    },
    shop_ware: {
      x: 2208,
      y: 2784,
      width: 96,
      height: 96,
    },
    shopify_graphql: {
      x: 2304,
      y: 2784,
      width: 96,
      height: 96,
    },
    shoprocket: {
      x: 2400,
      y: 2784,
      width: 96,
      height: 96,
    },
    shotstack: {
      x: 2496,
      y: 2784,
      width: 96,
      height: 96,
    },
    sidetracker: {
      x: 2592,
      y: 2784,
      width: 96,
      height: 96,
    },
    signable: {
      x: 2688,
      y: 2784,
      width: 96,
      height: 96,
    },
    signaturely: {
      x: 2784,
      y: 2784,
      width: 96,
      height: 96,
    },
    signrequest: {
      x: 2880,
      y: 0,
      width: 96,
      height: 96,
    },
    signwell: {
      x: 2880,
      y: 96,
      width: 96,
      height: 96,
    },
    simplebackups: {
      x: 2880,
      y: 192,
      width: 96,
      height: 96,
    },
    simplero: {
      x: 2880,
      y: 288,
      width: 96,
      height: 96,
    },
    simplescraper: {
      x: 2880,
      y: 384,
      width: 96,
      height: 96,
    },
    simpletexting: {
      x: 2880,
      y: 480,
      width: 96,
      height: 96,
    },
    simplicate: {
      x: 2880,
      y: 576,
      width: 96,
      height: 96,
    },
    skio: {
      x: 2880,
      y: 672,
      width: 96,
      height: 96,
    },
    skulabs: {
      x: 2880,
      y: 768,
      width: 96,
      height: 96,
    },
    skyprep: {
      x: 2880,
      y: 864,
      width: 96,
      height: 96,
    },
    skyslope: {
      x: 2880,
      y: 960,
      width: 96,
      height: 96,
    },
    slack_audit_api: {
      x: 2880,
      y: 1056,
      width: 96,
      height: 96,
    },
    slashid: {
      x: 2880,
      y: 1152,
      width: 96,
      height: 96,
    },
    slicktext: {
      x: 2880,
      y: 1248,
      width: 96,
      height: 96,
    },
    slite: {
      x: 2880,
      y: 1344,
      width: 96,
      height: 96,
    },
    smartlead_ai: {
      x: 2880,
      y: 1440,
      width: 96,
      height: 96,
    },
    smartreach: {
      x: 2880,
      y: 1536,
      width: 96,
      height: 96,
    },
    smartrr: {
      x: 2880,
      y: 1632,
      width: 96,
      height: 96,
    },
    smile_io: {
      x: 2880,
      y: 1728,
      width: 96,
      height: 96,
    },
    smoove: {
      x: 2880,
      y: 1824,
      width: 96,
      height: 96,
    },
    snapchat: {
      x: 2880,
      y: 1920,
      width: 96,
      height: 96,
    },
    snapdocs: {
      x: 2880,
      y: 2016,
      width: 96,
      height: 96,
    },
    snapdocs_mobile_notary: {
      x: 2880,
      y: 2112,
      width: 96,
      height: 96,
    },
    snov_io: {
      x: 2880,
      y: 2208,
      width: 96,
      height: 96,
    },
    solar: {
      x: 2880,
      y: 2304,
      width: 96,
      height: 96,
    },
    solarwinds_observability: {
      x: 2880,
      y: 2400,
      width: 96,
      height: 96,
    },
    sonderplan: {
      x: 1920,
      y: 3264,
      width: 96,
      height: 39,
    },
    sonix: {
      x: 2400,
      y: 3264,
      width: 96,
      height: 38,
    },
    sortly: {
      x: 1248,
      y: 3264,
      width: 96,
      height: 43,
    },
    soundee: {
      x: 2880,
      y: 2496,
      width: 96,
      height: 96,
    },
    sparkhire: {
      x: 2880,
      y: 2592,
      width: 96,
      height: 96,
    },
    speedcurve: {
      x: 2880,
      y: 2688,
      width: 96,
      height: 96,
    },
    spinupwp: {
      x: 3358,
      y: 508,
      width: 96,
      height: 16,
    },
    splitwise: {
      x: 2880,
      y: 2784,
      width: 96,
      height: 96,
    },
    splynx: {
      x: 0,
      y: 2880,
      width: 96,
      height: 96,
    },
    spoke_phone: {
      x: 96,
      y: 2880,
      width: 96,
      height: 96,
    },
    sportmonks: {
      x: 192,
      y: 2880,
      width: 96,
      height: 96,
    },
    spotdraft: {
      x: 288,
      y: 2880,
      width: 96,
      height: 96,
    },
    spotify_web: {
      x: 384,
      y: 2880,
      width: 96,
      height: 96,
    },
    spotme: {
      x: 480,
      y: 2880,
      width: 96,
      height: 96,
    },
    spreecommerce: {
      x: 576,
      y: 2880,
      width: 96,
      height: 96,
    },
    sqldbm: {
      x: 672,
      y: 2880,
      width: 96,
      height: 96,
    },
    stamped: {
      x: 768,
      y: 2880,
      width: 96,
      height: 96,
    },
    starion: {
      x: 0,
      y: 3314,
      width: 96,
      height: 31,
    },
    startinfinity: {
      x: 864,
      y: 2880,
      width: 96,
      height: 96,
    },
    starton: {
      x: 384,
      y: 3314,
      width: 96,
      height: 29,
    },
    statorium: {
      x: 3358,
      y: 524,
      width: 96,
      height: 16,
    },
    status_hero: {
      x: 960,
      y: 2880,
      width: 96,
      height: 96,
    },
    stay_ai: {
      x: 1056,
      y: 2880,
      width: 96,
      height: 96,
    },
    stedi: {
      x: 1152,
      y: 2880,
      width: 96,
      height: 96,
    },
    stellaconnect: {
      x: 1248,
      y: 2880,
      width: 96,
      height: 96,
    },
    stiply: {
      x: 1344,
      y: 2880,
      width: 96,
      height: 96,
    },
    stlouisfed: {
      x: 1440,
      y: 2880,
      width: 96,
      height: 96,
    },
    stord: {
      x: 1536,
      y: 2880,
      width: 96,
      height: 96,
    },
    storyblok: {
      x: 1632,
      y: 2880,
      width: 96,
      height: 96,
    },
    storychief: {
      x: 1728,
      y: 2880,
      width: 96,
      height: 96,
    },
    streamtime: {
      x: 1824,
      y: 2880,
      width: 96,
      height: 96,
    },
    stripe_connected_accounts: {
      x: 1920,
      y: 2880,
      width: 96,
      height: 96,
    },
    submittable: {
      x: 2016,
      y: 2880,
      width: 96,
      height: 96,
    },
    super_ai: {
      x: 2112,
      y: 2880,
      width: 96,
      height: 96,
    },
    super_dispatch: {
      x: 2208,
      y: 2880,
      width: 96,
      height: 96,
    },
    superfiliate: {
      x: 2304,
      y: 2880,
      width: 96,
      height: 96,
    },
    supersend: {
      x: 2400,
      y: 2880,
      width: 96,
      height: 96,
    },
    support_hub: {
      x: 2496,
      y: 2880,
      width: 96,
      height: 96,
    },
    surecart: {
      x: 2592,
      y: 2880,
      width: 96,
      height: 96,
    },
    surveycto: {
      x: 2688,
      y: 2880,
      width: 96,
      height: 96,
    },
    surveymonkey_apply: {
      x: 1536,
      y: 3264,
      width: 96,
      height: 42,
    },
    surveysparrow: {
      x: 2784,
      y: 2880,
      width: 96,
      height: 96,
    },
    swarmia: {
      x: 2880,
      y: 2880,
      width: 96,
      height: 96,
    },
    swell_is: {
      x: 2976,
      y: 0,
      width: 96,
      height: 96,
    },
    synap: {
      x: 2976,
      y: 96,
      width: 96,
      height: 96,
    },
    syncro: {
      x: 2976,
      y: 192,
      width: 96,
      height: 96,
    },
    synthesia: {
      x: 2976,
      y: 288,
      width: 96,
      height: 96,
    },
    sysco: {
      x: 2976,
      y: 384,
      width: 96,
      height: 96,
    },
    tableau: {
      x: 2976,
      y: 480,
      width: 96,
      height: 96,
    },
    tai_software: {
      x: 2976,
      y: 576,
      width: 96,
      height: 96,
    },
    talentlyft: {
      x: 2976,
      y: 672,
      width: 96,
      height: 96,
    },
    talkable: {
      x: 2976,
      y: 768,
      width: 96,
      height: 96,
    },
    talon_one: {
      x: 2976,
      y: 864,
      width: 96,
      height: 96,
    },
    tanda: {
      x: 2976,
      y: 960,
      width: 96,
      height: 96,
    },
    tango: {
      x: 2976,
      y: 1056,
      width: 96,
      height: 96,
    },
    tap: {
      x: 2976,
      y: 1152,
      width: 96,
      height: 96,
    },
    tapfiliate: {
      x: 2976,
      y: 1248,
      width: 96,
      height: 96,
    },
    targetprocess: {
      x: 2976,
      y: 1344,
      width: 96,
      height: 96,
    },
    tatum_io: {
      x: 2976,
      y: 1440,
      width: 96,
      height: 96,
    },
    taxamo: {
      x: 2976,
      y: 1536,
      width: 96,
      height: 96,
    },
    taxjar: {
      x: 2976,
      y: 1632,
      width: 96,
      height: 96,
    },
    teachable: {
      x: 2976,
      y: 1728,
      width: 96,
      height: 96,
    },
    teamup: {
      x: 2976,
      y: 1824,
      width: 96,
      height: 96,
    },
    telnyx: {
      x: 2976,
      y: 1920,
      width: 96,
      height: 96,
    },
    temi: {
      x: 2976,
      y: 2016,
      width: 96,
      height: 96,
    },
    tettra: {
      x: 2976,
      y: 2112,
      width: 96,
      height: 96,
    },
    textline: {
      x: 2976,
      y: 2208,
      width: 96,
      height: 96,
    },
    textmagic: {
      x: 2976,
      y: 2304,
      width: 96,
      height: 96,
    },
    thanx: {
      x: 2976,
      y: 2400,
      width: 96,
      height: 96,
    },
    the_trade_desk_delta: {
      x: 2976,
      y: 2496,
      width: 96,
      height: 96,
    },
    the_trade_desk_graphql: {
      x: 2976,
      y: 2592,
      width: 96,
      height: 96,
    },
    thought_industries: {
      x: 3168,
      y: 3264,
      width: 96,
      height: 32,
    },
    thrivecart: {
      x: 96,
      y: 3264,
      width: 96,
      height: 50,
    },
    ticketmaster_discovery: {
      x: 2976,
      y: 2688,
      width: 96,
      height: 96,
    },
    ticketsignup: {
      x: 2976,
      y: 2784,
      width: 96,
      height: 96,
    },
    tidycal: {
      x: 2976,
      y: 2880,
      width: 96,
      height: 96,
    },
    tilaa: {
      x: 0,
      y: 2976,
      width: 96,
      height: 96,
    },
    timecamp: {
      x: 96,
      y: 2976,
      width: 96,
      height: 96,
    },
    tines: {
      x: 192,
      y: 2976,
      width: 96,
      height: 96,
    },
    tink: {
      x: 288,
      y: 2976,
      width: 96,
      height: 96,
    },
    todoist: {
      x: 384,
      y: 2976,
      width: 96,
      height: 96,
    },
    token_metrics: {
      x: 480,
      y: 2976,
      width: 96,
      height: 96,
    },
    totango: {
      x: 576,
      y: 2976,
      width: 96,
      height: 96,
    },
    tovuti: {
      x: 672,
      y: 2976,
      width: 96,
      height: 96,
    },
    trackdesk: {
      x: 768,
      y: 2976,
      width: 96,
      height: 96,
    },
    trade_gov: {
      x: 864,
      y: 2976,
      width: 96,
      height: 96,
    },
    traffit: {
      x: 960,
      y: 2976,
      width: 96,
      height: 96,
    },
    traject: {
      x: 1056,
      y: 2976,
      width: 96,
      height: 96,
    },
    trakstar: {
      x: 1152,
      y: 2976,
      width: 96,
      height: 96,
    },
    transifex: {
      x: 1248,
      y: 2976,
      width: 96,
      height: 96,
    },
    transkriptor: {
      x: 1344,
      y: 2976,
      width: 96,
      height: 96,
    },
    trax: {
      x: 1440,
      y: 2976,
      width: 96,
      height: 96,
    },
    treasury_gov: {
      x: 1536,
      y: 2976,
      width: 96,
      height: 96,
    },
    tree_nation: {
      x: 1632,
      y: 2976,
      width: 96,
      height: 96,
    },
    trengo: {
      x: 1728,
      y: 2976,
      width: 96,
      height: 96,
    },
    trestle: {
      x: 1824,
      y: 2976,
      width: 96,
      height: 96,
    },
    trinet: {
      x: 1920,
      y: 2976,
      width: 96,
      height: 96,
    },
    trint: {
      x: 2016,
      y: 2976,
      width: 96,
      height: 96,
    },
    tripleseat: {
      x: 2112,
      y: 2976,
      width: 96,
      height: 96,
    },
    trumpia: {
      x: 2208,
      y: 2976,
      width: 96,
      height: 96,
    },
    trustradius: {
      x: 2304,
      y: 2976,
      width: 96,
      height: 96,
    },
    tune: {
      x: 2400,
      y: 2976,
      width: 96,
      height: 96,
    },
    twitch: {
      x: 1727,
      y: 3168,
      width: 96,
      height: 73,
    },
    uber_eats: {
      x: 2496,
      y: 2976,
      width: 96,
      height: 96,
    },
    uberall: {
      x: 2592,
      y: 2976,
      width: 96,
      height: 96,
    },
    uberflip: {
      x: 2688,
      y: 2976,
      width: 96,
      height: 96,
    },
    uk_environment_agency_flood_monitoring: {
      x: 2784,
      y: 2976,
      width: 96,
      height: 96,
    },
    ukg_pro_learning: {
      x: 2880,
      y: 2976,
      width: 96,
      height: 96,
    },
    ukg_ready: {
      x: 2976,
      y: 2976,
      width: 96,
      height: 96,
    },
    umami_is: {
      x: 3072,
      y: 0,
      width: 96,
      height: 96,
    },
    unanet: {
      x: 3072,
      y: 96,
      width: 96,
      height: 96,
    },
    unanet_cosential: {
      x: 3072,
      y: 192,
      width: 96,
      height: 96,
    },
    unbounce: {
      x: 3358,
      y: 368,
      width: 96,
      height: 19,
    },
    unione: {
      x: 3072,
      y: 288,
      width: 96,
      height: 96,
    },
    universe: {
      x: 3072,
      y: 384,
      width: 96,
      height: 96,
    },
    updown: {
      x: 3072,
      y: 480,
      width: 96,
      height: 96,
    },
    upguard_cyberrisk: {
      x: 3072,
      y: 576,
      width: 96,
      height: 96,
    },
    uphance: {
      x: 3072,
      y: 672,
      width: 96,
      height: 96,
    },
    uplead: {
      x: 3072,
      y: 768,
      width: 96,
      height: 96,
    },
    uptime: {
      x: 3072,
      y: 864,
      width: 96,
      height: 96,
    },
    upwave: {
      x: 3072,
      y: 960,
      width: 96,
      height: 96,
    },
    us_census: {
      x: 3072,
      y: 1056,
      width: 96,
      height: 96,
    },
    usajobs: {
      x: 3072,
      y: 1152,
      width: 96,
      height: 96,
    },
    user: {
      x: 3072,
      y: 1248,
      width: 96,
      height: 96,
    },
    userflow: {
      x: 3072,
      y: 1344,
      width: 96,
      height: 96,
    },
    useriq: {
      x: 3072,
      y: 1440,
      width: 96,
      height: 96,
    },
    usersnap: {
      x: 3072,
      y: 1536,
      width: 96,
      height: 96,
    },
    usgs_earthquake_catalog: {
      x: 3072,
      y: 1632,
      width: 96,
      height: 96,
    },
    uxcam: {
      x: 3072,
      y: 1728,
      width: 96,
      height: 96,
    },
    uxsniff: {
      x: 3072,
      y: 1824,
      width: 96,
      height: 96,
    },
    vbout: {
      x: 3072,
      y: 1920,
      width: 96,
      height: 96,
    },
    vcita: {
      x: 3072,
      y: 2016,
      width: 96,
      height: 96,
    },
    vectara: {
      x: 3072,
      y: 2112,
      width: 96,
      height: 96,
    },
    venly: {
      x: 3072,
      y: 2208,
      width: 96,
      height: 96,
    },
    vercel: {
      x: 3072,
      y: 2304,
      width: 96,
      height: 96,
    },
    versapay: {
      x: 3072,
      y: 2400,
      width: 96,
      height: 96,
    },
    vertafore: {
      x: 3072,
      y: 2496,
      width: 96,
      height: 96,
    },
    vestaboard: {
      x: 3072,
      y: 2592,
      width: 96,
      height: 96,
    },
    vetspire: {
      x: 3072,
      y: 2688,
      width: 96,
      height: 96,
    },
    vibe: {
      x: 3072,
      y: 2784,
      width: 96,
      height: 96,
    },
    victorops: {
      x: 3072,
      y: 2880,
      width: 96,
      height: 96,
    },
    vidyard: {
      x: 192,
      y: 3264,
      width: 96,
      height: 50,
    },
    viewpoint: {
      x: 3072,
      y: 2976,
      width: 96,
      height: 96,
    },
    vindicia: {
      x: 0,
      y: 3072,
      width: 96,
      height: 96,
    },
    viral_loops: {
      x: 96,
      y: 3072,
      width: 96,
      height: 96,
    },
    viralsweep: {
      x: 192,
      y: 3072,
      width: 96,
      height: 96,
    },
    virtual_incentives: {
      x: 288,
      y: 3072,
      width: 96,
      height: 96,
    },
    virtualbadge_io: {
      x: 384,
      y: 3072,
      width: 96,
      height: 96,
    },
    virtuous: {
      x: 480,
      y: 3072,
      width: 96,
      height: 96,
    },
    virustotal: {
      x: 576,
      y: 3072,
      width: 96,
      height: 96,
    },
    vitruvi: {
      x: 192,
      y: 3314,
      width: 96,
      height: 30,
    },
    vivocalendar: {
      x: 1056,
      y: 3314,
      width: 96,
      height: 27,
    },
    voiso: {
      x: 672,
      y: 3072,
      width: 96,
      height: 96,
    },
    volunteerhub: {
      x: 768,
      y: 3072,
      width: 96,
      height: 96,
    },
    vomo: {
      x: 864,
      y: 3072,
      width: 96,
      height: 96,
    },
    vouchfor: {
      x: 960,
      y: 3072,
      width: 96,
      height: 96,
    },
    vtiger: {
      x: 1056,
      y: 3072,
      width: 96,
      height: 96,
    },
    vultr: {
      x: 1152,
      y: 3072,
      width: 96,
      height: 96,
    },
    wachete: {
      x: 1248,
      y: 3072,
      width: 96,
      height: 96,
    },
    waitlist: {
      x: 1344,
      y: 3072,
      width: 96,
      height: 96,
    },
    walichat: {
      x: 1440,
      y: 3072,
      width: 96,
      height: 96,
    },
    walkme: {
      x: 1536,
      y: 3072,
      width: 96,
      height: 96,
    },
    walls_io: {
      x: 1632,
      y: 3072,
      width: 96,
      height: 96,
    },
    wanikani: {
      x: 1728,
      y: 3072,
      width: 96,
      height: 96,
    },
    watchmode: {
      x: 1824,
      y: 3072,
      width: 96,
      height: 96,
    },
    watersignal: {
      x: 1920,
      y: 3072,
      width: 96,
      height: 96,
    },
    wati: {
      x: 2016,
      y: 3072,
      width: 96,
      height: 96,
    },
    waveline_extract: {
      x: 2112,
      y: 3072,
      width: 96,
      height: 96,
    },
    wavely: {
      x: 2208,
      y: 3072,
      width: 96,
      height: 96,
    },
    wealthbox: {
      x: 2304,
      y: 3072,
      width: 96,
      height: 96,
    },
    weather_gov: {
      x: 2400,
      y: 3072,
      width: 96,
      height: 96,
    },
    webex: {
      x: 2496,
      y: 3072,
      width: 96,
      height: 96,
    },
    webflow: {
      x: 2592,
      y: 3072,
      width: 96,
      height: 96,
    },
    webinarfuel: {
      x: 3358,
      y: 597,
      width: 96,
      height: 13,
    },
    webinargeek: {
      x: 2688,
      y: 3072,
      width: 96,
      height: 96,
    },
    whatconverts: {
      x: 2784,
      y: 3072,
      width: 96,
      height: 96,
    },
    whispir: {
      x: 288,
      y: 3264,
      width: 96,
      height: 50,
    },
    whitehatsec: {
      x: 2880,
      y: 3072,
      width: 96,
      height: 96,
    },
    willo: {
      x: 2976,
      y: 3072,
      width: 96,
      height: 96,
    },
    winedirect: {
      x: 3072,
      y: 3072,
      width: 96,
      height: 96,
    },
    winedirect_fulfillment: {
      x: 3168,
      y: 0,
      width: 96,
      height: 96,
    },
    wise: {
      x: 3358,
      y: 67,
      width: 96,
      height: 22,
    },
    wisepops: {
      x: 3168,
      y: 96,
      width: 96,
      height: 96,
    },
    withorb: {
      x: 3168,
      y: 192,
      width: 96,
      height: 96,
    },
    wonderpush: {
      x: 3168,
      y: 288,
      width: 96,
      height: 96,
    },
    woodpecker_co: {
      x: 3168,
      y: 384,
      width: 96,
      height: 96,
    },
    wootric: {
      x: 3168,
      y: 480,
      width: 96,
      height: 96,
    },
    woovi: {
      x: 3168,
      y: 576,
      width: 96,
      height: 96,
    },
    workast: {
      x: 3168,
      y: 672,
      width: 96,
      height: 96,
    },
    workato: {
      x: 3168,
      y: 768,
      width: 96,
      height: 96,
    },
    workday_raas: {
      x: 3168,
      y: 864,
      width: 96,
      height: 96,
    },
    workiom: {
      x: 3168,
      y: 960,
      width: 96,
      height: 96,
    },
    workiz: {
      x: 3168,
      y: 1056,
      width: 96,
      height: 96,
    },
    workos: {
      x: 3168,
      y: 1152,
      width: 96,
      height: 96,
    },
    workstream: {
      x: 863,
      y: 3168,
      width: 96,
      height: 95,
    },
    worksuite: {
      x: 3168,
      y: 1248,
      width: 96,
      height: 96,
    },
    worldbank: {
      x: 384,
      y: 3264,
      width: 96,
      height: 50,
    },
    wrangle: {
      x: 768,
      y: 3314,
      width: 96,
      height: 28,
    },
    wufoo: {
      x: 3168,
      y: 1344,
      width: 96,
      height: 96,
    },
    wyscout: {
      x: 3168,
      y: 1440,
      width: 96,
      height: 96,
    },
    xata: {
      x: 3168,
      y: 1536,
      width: 96,
      height: 96,
    },
    xmatters: {
      x: 3168,
      y: 1632,
      width: 96,
      height: 96,
    },
    xobin: {
      x: 3168,
      y: 1728,
      width: 96,
      height: 96,
    },
    xola: {
      x: 1055,
      y: 3168,
      width: 96,
      height: 94,
    },
    xprt: {
      x: 3168,
      y: 1824,
      width: 96,
      height: 96,
    },
    xtract: {
      x: 3168,
      y: 1920,
      width: 96,
      height: 96,
    },
    yelp: {
      x: 3168,
      y: 2016,
      width: 96,
      height: 96,
    },
    yodiz: {
      x: 3168,
      y: 2112,
      width: 96,
      height: 96,
    },
    yoplanning: {
      x: 3168,
      y: 2208,
      width: 96,
      height: 96,
    },
    yotpo_ugc: {
      x: 3168,
      y: 2304,
      width: 96,
      height: 96,
    },
    younoodle: {
      x: 3168,
      y: 2400,
      width: 96,
      height: 96,
    },
    your_surveys: {
      x: 3264,
      y: 192,
      width: 90,
      height: 96,
    },
    youraspire: {
      x: 3168,
      y: 2496,
      width: 96,
      height: 96,
    },
    yousign: {
      x: 1152,
      y: 3314,
      width: 96,
      height: 27,
    },
    zabbix: {
      x: 3168,
      y: 2592,
      width: 96,
      height: 96,
    },
    zagomail: {
      x: 3168,
      y: 2688,
      width: 96,
      height: 96,
    },
    zakeke: {
      x: 3168,
      y: 2784,
      width: 96,
      height: 96,
    },
    zenedu: {
      x: 3168,
      y: 2880,
      width: 96,
      height: 96,
    },
    zenhub: {
      x: 3168,
      y: 2976,
      width: 96,
      height: 96,
    },
    zenkit: {
      x: 3168,
      y: 3072,
      width: 96,
      height: 96,
    },
    zenloop: {
      x: 0,
      y: 3168,
      width: 96,
      height: 96,
    },
    zenoti: {
      x: 1248,
      y: 3314,
      width: 96,
      height: 27,
    },
    zesty: {
      x: 96,
      y: 3168,
      width: 96,
      height: 96,
    },
    zilliz: {
      x: 192,
      y: 3168,
      width: 96,
      height: 96,
    },
    zinc: {
      x: 288,
      y: 3168,
      width: 96,
      height: 96,
    },
    zinrelo: {
      x: 384,
      y: 3168,
      width: 96,
      height: 96,
    },
    zixflow: {
      x: 480,
      y: 3168,
      width: 96,
      height: 96,
    },
    zohobilling: {
      x: 576,
      y: 3168,
      width: 96,
      height: 96,
    },
    zulip: {
      x: 672,
      y: 3168,
      width: 96,
      height: 96,
    },
    zylo: {
      x: 1344,
      y: 3314,
      width: 96,
      height: 27,
    },
  },
};
export default spriteSheet;
